import store from '@/store';
import axios from '@/plugins/axios';

export default {
  getClientCategories: async function () {
    try {
      store.commit('SET_PORTFOLIO_CATEGORIES', [
        {
          id: 1,
          name: '기술문서 제작',
          url: '기술문서-제작',
          date_added: '2022-05-15T17:02:02.000Z',
        },
        {
          id: 3,
          name: '문서 관리 솔루션',
          url: '문서-관리-솔루션',
          date_added: '2022-05-15T17:02:18.000Z',
        },
        {
          id: 2,
          name: '번역.현지화',
          url: '번역-현지화',
          date_added: '2022-05-15T17:02:10.000Z',
        },
        {
          id: 4,
          name: '시뮬레이터 개발',
          url: '시뮬레이터-개발',
          date_added: '2023-01-20T01:08:58.000Z',
        },
      ]);
      let response = await axios({
        method: 'post',
        url: '/api/portfolio/categories',
      });
      store.commit(
        'SET_PORTFOLIO_CATEGORIES',
        response.data.categories || []
      );
    } catch {
      console.log('error fetching categories');
    }
  },

  getClientSectors: async function () {
    try {
      store.commit('SET_PORTFOLIO_SECTORS', [
        {
          id: 5,
          name: 'GUI',
          url: 'gui',
          date_added: '2022-05-09T21:06:31.000Z',
          shown: 1,
        },
        {
          id: 10,
          name: '교육 시뮬레이터',
          url: '교육-시뮬레이터',
          date_added: '2023-01-20T03:43:07.000Z',
          shown: 1,
        },
        {
          id: 6,
          name: '기술 문서 관리 ',
          url: '기술-문서-관리',
          date_added: '2022-05-09T21:07:45.000Z',
          shown: 1,
        },
        {
          id: 3,
          name: '다국어 번역',
          url: '다국어-번역',
          date_added: '2022-05-09T21:04:34.000Z',
          shown: 1,
        },
        {
          id: 4,
          name: '소프트웨어​  매뉴얼',
          url: '소프트웨어​-매뉴얼',
          date_added: '2022-05-09T21:05:07.000Z',
          shown: 1,
        },
        {
          id: 7,
          name: '웹 매뉴얼',
          url: '웹-매뉴얼',
          date_added: '2022-05-09T21:07:52.000Z',
          shown: 1,
        },
        {
          id: 8,
          name: '웹 퍼블리싱',
          url: '웹-퍼블리싱',
          date_added: '2022-05-09T21:07:58.000Z',
          shown: 1,
        },
        {
          id: 1,
          name: '제품 설명서',
          url: '제품-설명서',
          date_added: '2022-05-09T02:34:18.000Z',
          shown: 1,
        },
        {
          id: 2,
          name: '제품 카탈로그 ',
          url: '제품-카탈로그',
          date_added: '2022-05-09T02:38:24.000Z',
          shown: 1,
        },
      ]);
      let response = await axios({
        method: 'post',
        url: '/api/portfolio/sectors',
      });
      store.commit(
        'SET_PORTFOLIO_SECTORS',
        response.data.sectors || []
      );
    } catch {
      console.log('error fetching sectors');
    }
  },
  getClientIndustries: async function () {
    try {
      store.commit('SET_PORTFOLIO_INDUSTRIES', [
        {
          id: 4,
          name: 'IT 분야',
          url: 'it-분야',
          date_added: '2022-05-09T21:06:04.000Z',
        },
        {
          id: 8,
          name: '교육',
          url: '교육',
          date_added: '2022-05-09T22:12:59.000Z',
        },
        {
          id: 7,
          name: '반도체 장비',
          url: '반도체-장비',
          date_added: '2022-05-09T22:05:36.000Z',
        },
        {
          id: 2,
          name: '산업 장비',
          url: '산업-장비',
          date_added: '2022-05-09T21:04:48.000Z',
        },
        {
          id: 6,
          name: '생활 용품',
          url: '생활-용품',
          date_added: '2022-05-09T21:08:27.000Z',
        },
        {
          id: 1,
          name: '생활가전',
          url: '생활가전',
          date_added: '2022-05-09T06:06:20.000Z',
        },
        {
          id: 3,
          name: '의료 장비',
          url: '의료-장비',
          date_added: '2022-05-09T21:05:44.000Z',
        },
        {
          id: 9,
          name: '자동차',
          url: '자동차',
          date_added: '2022-11-06T17:26:31.000Z',
        },
        {
          id: 5,
          name: '조선',
          url: '조선',
          date_added: '2022-05-09T21:08:13.000Z',
        },
      ]);
      let response = await axios({
        method: 'post',
        url: '/api/portfolio/industries',
      });
      store.commit(
        'SET_PORTFOLIO_INDUSTRIES',
        response.data.industries || []
      );
    } catch {
      console.log('error fetching industries');
    }
  },

  getClients: async function () {
    try {
      store.commit('SET_PORTFOLIO_CLIENTS', [
        {
          id: 65,
          image_thumb_url: '/media/20220510/thumb-1652163461.jpg',
          image_url: '/media/20220510/1652163461.jpg',
          name: '에코 파워텍',
          subname: '',
          description:
            '<p>&nbsp;</p>\n<ul>\n<li>사용자가 소프트웨어 사용에 필요한 절차, 환경 등의 제반 사항이 모두 포함되도록 작성된 소프트웨어 매뉴얼 제작</li>\n</ul>',
          logos: [128, 0],
          date_published: '2024-02-16T06:25:22.000Z',
          main_cat: 2,
          categories: [2],
          industries: [2],
          sectors: [3, 4],
          logoFiles: [
            {
              id: 128,
              name: 'ECOPowertec.png',
              url: '/media/20220510/1652163451.png',
              thumb_url: '/media/20220510/thumb-1652163451.png',
              mimetype: 'image/png',
              size: 29594,
              date_uploaded: '2022-05-09T21:17:31.000Z',
              uploader_id: 1,
            },
          ],
        },
        {
          id: 64,
          image_thumb_url: '/media/20220510/thumb-1652165887.jpg',
          image_url: '/media/20220510/1652165887.jpg',
          name: 'Samsung',
          subname: '',
          description:
            '<p>&nbsp;</p>\n<ul>\n<li>네트워크 매뉴얼 전용 클라이언트 (안드로이드, iOS, 윈도우)</li>\n<li>온/오프라인 로그인 기능</li>\n<li>문서 검색, 열람, 다운로드, 북마크, Q&amp;A 기능</li>\n<li>다운로드 문서 자동 업데이트 기능</li>\n</ul>',
          logos: [172, 0],
          date_published: '2024-02-16T06:23:11.000Z',
          main_cat: 2,
          categories: [2],
          industries: [4],
          sectors: [3, 5],
          logoFiles: [
            {
              id: 172,
              name: 'Samsung_Logo.png',
              url: '/media/20220510/1652167585.png',
              thumb_url: '/media/20220510/thumb-1652167585.png',
              mimetype: 'image/png',
              size: 13250,
              date_uploaded: '2022-05-09T22:26:25.000Z',
              uploader_id: 1,
            },
          ],
        },
        {
          id: 63,
          image_thumb_url: '/media/20220510/thumb-1652166001.jpg',
          image_url: '/media/20220510/1652166001.jpg',
          name: '에스원',
          subname: '',
          description:
            '<p>&nbsp;</p>\n<ul>\n<li>기존의 GUI를 개선하고 디자인 컨셉과 가이드에 맞게 새로운 프로그램 GUI 제작</li>\n</ul>',
          logos: [148, 0],
          date_published: '2024-02-16T06:18:04.000Z',
          main_cat: 2,
          categories: [2],
          industries: [4],
          sectors: [5, 3],
          logoFiles: [
            {
              id: 148,
              name: 'S1_logo.png',
              url: '/media/20220510/1652165992.png',
              thumb_url: '/media/20220510/thumb-1652165992.png',
              mimetype: 'image/png',
              size: 12676,
              date_uploaded: '2022-05-09T21:59:52.000Z',
              uploader_id: 1,
            },
          ],
        },
        {
          id: 62,
          image_thumb_url: '/media/20220510/thumb-1652165053.jpg',
          image_url: '/media/20220510/1652165053.jpg',
          name: 'HFR',
          subname: '',
          description:
            '<p>&nbsp;</p>\n<ul>\n<li>제품 홍보를 목적으로 모든 제품군에 대한 특징과 장점을 설명하는 종합 제품 카탈로그, 브로슈어 제작</li>\n<li>제품과 기업에 대한 이미지를 시각적으로 임팩트 있게 표현할 수 있는 포스터 제작</li>\n</ul>',
          logos: [213, 0],
          date_published: '2024-02-16T06:10:15.000Z',
          main_cat: 2,
          categories: [2],
          industries: [2],
          sectors: [3, 2],
          logoFiles: [
            {
              id: 213,
              name: 'HGR, Inc.png',
              url: '/media/20220527/1653632029.png',
              thumb_url: '/media/20220527/thumb-1653632029.png',
              mimetype: 'image/png',
              size: 17447,
              date_uploaded: '2022-05-26T21:13:49.000Z',
              uploader_id: 1,
            },
          ],
        },
        {
          id: 61,
          image_thumb_url: '/media/20230713/thumb-1689255120.jpg',
          image_url:
            '/media/20230713/1689255120-MicrosoftTeams-image%20(1).png',
          name: '모트렉스',
          subname: '',
          description:
            '<div style="language: en-US; line-height: 150%; margin-top: 0pt; margin-bottom: 0pt; margin-left: .2in; text-indent: -.2in; text-align: left; direction: ltr; unicode-bidi: embed; mso-line-break-override: none; word-break: normal; punctuation-wrap: hanging;">&nbsp;</div>\n<div style="language: en-US; line-height: 150%; margin-top: 0pt; margin-bottom: 0pt; margin-left: .2in; text-indent: -.2in; text-align: left; direction: ltr; unicode-bidi: embed; mso-line-break-override: none; word-break: normal; punctuation-wrap: hanging;"><span style="font-size: 10.5pt;"><span style="mso-special-format: bullet; font-family: Arial;">&bull;</span></span><span style="font-size: 10.5pt; font-family: 나눔스퀘어; mso-ascii-font-family: 나눔스퀘어; mso-fareast-font-family: 나눔스퀘어; mso-bidi-font-family: +mn-cs; mso-bidi-theme-font: minor-bidi; color: #5f5f5f; mso-font-kerning: 12.0pt; language: ko; mso-style-textfill-type: solid; mso-style-textfill-fill-color: #5F5F5F; mso-style-textfill-fill-alpha: 100.0%;">차량용 인포테인먼트 시스템 콘텐츠에 대한 다국어 번역</span></div>\n<div style="language: en-US; line-height: 150%; margin-top: 0pt; margin-bottom: 0pt; margin-left: .2in; text-indent: -.2in; text-align: left; direction: ltr; unicode-bidi: embed; mso-line-break-override: none; word-break: normal; punctuation-wrap: hanging;"><span style="font-size: 10.5pt;"><span style="mso-special-format: bullet; font-family: Arial;">&bull;</span></span><span style="font-size: 10.5pt; font-family: 나눔스퀘어; mso-ascii-font-family: 나눔스퀘어; mso-fareast-font-family: 나눔스퀘어; mso-bidi-font-family: +mn-cs; mso-bidi-theme-font: minor-bidi; color: #5f5f5f; mso-font-kerning: 12.0pt; language: ko; mso-style-textfill-type: solid; mso-style-textfill-fill-color: #5F5F5F; mso-style-textfill-fill-alpha: 100.0%;">기존 매뉴얼의 다국어 번역 및 인쇄 매뉴얼을 웹 매뉴얼로 퍼블리싱</span></div>',
          logos: [1232, 0],
          date_published: '2024-02-16T05:48:30.000Z',
          main_cat: 2,
          categories: [2],
          industries: [9],
          sectors: [3, 7],
          logoFiles: [
            {
              id: 1232,
              name: 'motrex_logo.jpg',
              url: '/media/20230713/1689255045-motrex_logo.jpg',
              thumb_url: '/media/20230713/thumb-1689255045.jpg',
              mimetype: 'image/jpeg',
              size: 50844,
              date_uploaded: '2023-07-13T13:30:45.000Z',
              uploader_id: 1,
            },
          ],
        },
        {
          id: 57,
          image_thumb_url: '/media/20231031/thumb-1698727695.jpg',
          image_url:
            '/media/20231031/1698727695-덴티움포트폴리오.jpg',
          name: '덴티움',
          subname: '',
          description:
            '<p style="language: ko; line-height: 150%; margin-top: 0pt; margin-bottom: 0pt; margin-left: 0in; text-align: left; direction: ltr; unicode-bidi: embed; mso-line-break-override: none; word-break: keep-all; punctuation-wrap: hanging;"><span style="color: #000000;"><span style="font-size: 11pt; font-family: \'나눔스퀘어 Bold\'; font-weight: bold;">의료기기 </span><span style="font-size: 11pt; font-family: \'나눔스퀘어 Bold\'; font-weight: bold;">bright X-ray</span><span style="font-size: 11pt; font-family: \'나눔스퀘어 Bold\'; font-weight: bold;"> 사용자 매뉴얼 디자인 </span></span></p>\n<p style="language: ko; line-height: 150%; margin-top: 0pt; margin-bottom: 0pt; margin-left: 0in; text-align: left; direction: ltr; unicode-bidi: embed; mso-line-break-override: none; word-break: keep-all; punctuation-wrap: hanging;"><span style="color: #000000;"><span style="font-size: 11pt; font-family: \'나눔스퀘어 Bold\'; font-weight: bold;">(2023</span><span style="font-size: 11pt; font-family: \'나눔스퀘어 Bold\'; font-weight: bold;">년 </span><span style="font-size: 11pt; font-family: \'나눔스퀘어 Bold\'; font-weight: bold;">8</span><span style="font-size: 11pt; font-family: \'나눔스퀘어 Bold\'; font-weight: bold;">월</span><span style="font-size: 11pt; font-family: \'나눔스퀘어 Bold\'; font-weight: bold;">)</span></span></p>\n<p style="language: ko; line-height: 150%; margin-top: 0pt; margin-bottom: 0pt; margin-left: 0in; text-align: left; direction: ltr; unicode-bidi: embed; mso-line-break-override: none; word-break: keep-all; punctuation-wrap: hanging;">&nbsp;</p>\n<div class="O0" style="language: ko; line-height: 150%; margin-top: 0pt; margin-bottom: 0pt; margin-left: .2in; text-indent: -.2in; text-align: left; direction: ltr; unicode-bidi: embed; mso-line-break-override: none; word-break: keep-all; punctuation-wrap: hanging;"><span style="font-size: 10.5pt;"><span style="mso-special-format: bullet; font-family: Arial;">&bull; </span></span><span style="font-size: 10.5pt; font-family: 나눔스퀘어; mso-ascii-font-family: 나눔스퀘어; mso-fareast-font-family: 나눔스퀘어; mso-bidi-font-family: +mn-cs; mso-bidi-theme-font: minor-bidi; color: #5f5f5f; mso-font-kerning: 12.0pt; language: ko; mso-style-textfill-type: solid; mso-style-textfill-fill-color: #5F5F5F; mso-style-textfill-fill-alpha: 100.0%;">사용자가 제품 구매 후 기본적인 사용법을 익히고 </span></div>\n<div class="O0" style="language: ko; line-height: 150%; margin-top: 0pt; margin-bottom: 0pt; margin-left: .2in; text-indent: -.2in; text-align: left; direction: ltr; unicode-bidi: embed; mso-line-break-override: none; word-break: keep-all; punctuation-wrap: hanging;"><span style="font-size: 10.5pt; font-family: 나눔스퀘어; mso-ascii-font-family: 나눔스퀘어; mso-fareast-font-family: 나눔스퀘어; mso-bidi-font-family: +mn-cs; mso-bidi-theme-font: minor-bidi; color: #5f5f5f; mso-font-kerning: 12.0pt; language: ko; mso-style-textfill-type: solid; mso-style-textfill-fill-color: #5F5F5F; mso-style-textfill-fill-alpha: 100.0%;">&nbsp; 적절한 유지보수 방법 및 보증 내용에 대해 이해를 </span></div>\n<div class="O0" style="language: ko; line-height: 150%; margin-top: 0pt; margin-bottom: 0pt; margin-left: .2in; text-indent: -.2in; text-align: left; direction: ltr; unicode-bidi: embed; mso-line-break-override: none; word-break: keep-all; punctuation-wrap: hanging;"><span style="font-size: 10.5pt; font-family: 나눔스퀘어; mso-ascii-font-family: 나눔스퀘어; mso-fareast-font-family: 나눔스퀘어; mso-bidi-font-family: +mn-cs; mso-bidi-theme-font: minor-bidi; color: #5f5f5f; mso-font-kerning: 12.0pt; language: ko; mso-style-textfill-type: solid; mso-style-textfill-fill-color: #5F5F5F; mso-style-textfill-fill-alpha: 100.0%;">&nbsp; 돕는 제품 설명서​ 제작</span></div>\n<div class="O0" style="language: ko; line-height: 150%; margin-top: 0pt; margin-bottom: 0pt; margin-left: .2in; text-indent: -.2in; text-align: left; direction: ltr; unicode-bidi: embed; mso-line-break-override: none; word-break: keep-all; punctuation-wrap: hanging;"><span style="font-size: 10.5pt;"><span style="mso-special-format: bullet; font-family: Arial;">&bull; </span></span><span style="font-size: 10.5pt; font-family: 나눔스퀘어; mso-ascii-font-family: 나눔스퀘어; mso-fareast-font-family: 나눔스퀘어; mso-bidi-font-family: +mn-cs; mso-bidi-theme-font: minor-bidi; color: #5f5f5f; mso-font-kerning: 12.0pt; language: ko; mso-style-textfill-type: solid; mso-style-textfill-fill-color: #5F5F5F; mso-style-textfill-fill-alpha: 100.0%;">고급 모델 포지셔닝으로 매뉴얼의 문서 레이아웃이 </span></div>\n<div class="O0" style="language: ko; line-height: 150%; margin-top: 0pt; margin-bottom: 0pt; margin-left: .2in; text-indent: -.2in; text-align: left; direction: ltr; unicode-bidi: embed; mso-line-break-override: none; word-break: keep-all; punctuation-wrap: hanging;"><span style="font-size: 10.5pt; font-family: 나눔스퀘어; mso-ascii-font-family: 나눔스퀘어; mso-fareast-font-family: 나눔스퀘어; mso-bidi-font-family: +mn-cs; mso-bidi-theme-font: minor-bidi; color: #5f5f5f; mso-font-kerning: 12.0pt; language: ko; mso-style-textfill-type: solid; mso-style-textfill-fill-color: #5F5F5F; mso-style-textfill-fill-alpha: 100.0%;">&nbsp; 아닌 디자인 요소가 반영된 제품 설명서​ 제작</span></div>',
          logos: [1392, 0],
          date_published: '2023-10-31T04:48:26.000Z',
          main_cat: 1,
          categories: [1],
          industries: [3],
          sectors: [1],
          logoFiles: [
            {
              id: 1392,
              name: '덴티움로고.jpg',
              url: '/media/20231031/1698727685-덴티움로고.jpg',
              thumb_url: '/media/20231031/1698727685-덴티움로고.jpg',
              mimetype: 'image/jpeg',
              size: 2824,
              date_uploaded: '2023-10-31T04:48:05.000Z',
              uploader_id: 6,
            },
          ],
        },
        {
          id: 56,
          image_thumb_url: '/media/20231031/thumb-1698726815.jpg',
          image_url:
            '/media/20231031/1698726815-현대엘리베이터포트폴리오.jpg',
          name: '현대엘리베이터',
          subname: '',
          description:
            '<p style="line-height: 150%; margin-top: 0pt; margin-bottom: 0pt; margin-left: 0in; direction: ltr; unicode-bidi: embed; word-break: keep-all;"><span style="color: #000000;"><span style="font-size: 11pt; font-family: \'나눔스퀘어 Bold\'; font-weight: bold;">현대엘리베이터 </span><span style="font-size: 11pt; font-family: \'나눔스퀘어 Bold\'; font-weight: bold;">제어반</span><span style="font-size: 11pt; font-family: \'나눔스퀘어 Bold\'; font-weight: bold;"> 카탈로그 디자인 </span><span style="font-size: 11pt; font-family: \'나눔스퀘어 Bold\'; font-weight: bold;">(2023</span><span style="font-size: 11pt; font-family: \'나눔스퀘어 Bold\'; font-weight: bold;">년 </span><span style="font-size: 11pt; font-family: \'나눔스퀘어 Bold\'; font-weight: bold;">4</span><span style="font-size: 11pt; font-family: \'나눔스퀘어 Bold\'; font-weight: bold;">월</span><span style="font-size: 11pt; font-family: \'나눔스퀘어 Bold\'; font-weight: bold;">)</span></span></p>\n<p style="line-height: 150%; margin-top: 0pt; margin-bottom: 0pt; margin-left: 0in; direction: ltr; unicode-bidi: embed; word-break: keep-all;">&nbsp;</p>\n<div class="O0" style="line-height: 150%; margin-top: 0pt; margin-bottom: 0pt; margin-left: 0.2in; text-indent: -0.2in; direction: ltr; unicode-bidi: embed; word-break: keep-all;"><span style="font-size: 10.5pt;"><span style="mso-special-format: bullet; font-family: Arial;">&bull; </span></span><span style="font-size: 10.5pt; font-family: 나눔스퀘어; mso-ascii-font-family: 나눔스퀘어; mso-fareast-font-family: 나눔스퀘어; mso-bidi-font-family: +mn-cs; mso-bidi-theme-font: minor-bidi; color: #5f5f5f; mso-font-kerning: 12.0pt; language: ko; mso-style-textfill-type: solid; mso-style-textfill-fill-color: #5F5F5F; mso-style-textfill-fill-alpha: 100.0%;">사용자가 제품 구매 후 기본적인 사용법을 익히고 적절한 </span></div>\n<div class="O0" style="line-height: 150%; margin-top: 0pt; margin-bottom: 0pt; margin-left: 0.2in; text-indent: -0.2in; direction: ltr; unicode-bidi: embed; word-break: keep-all;"><span style="font-size: 10.5pt; font-family: 나눔스퀘어; mso-ascii-font-family: 나눔스퀘어; mso-fareast-font-family: 나눔스퀘어; mso-bidi-font-family: +mn-cs; mso-bidi-theme-font: minor-bidi; color: #5f5f5f; mso-font-kerning: 12.0pt; language: ko; mso-style-textfill-type: solid; mso-style-textfill-fill-color: #5F5F5F; mso-style-textfill-fill-alpha: 100.0%;">&nbsp; 유지보수 방법 및 보증 내용에 </span><span style="font-size: 10.5pt; font-family: 나눔스퀘어; mso-ascii-font-family: 나눔스퀘어; mso-fareast-font-family: 나눔스퀘어; mso-bidi-font-family: +mn-cs; mso-bidi-theme-font: minor-bidi; color: #5f5f5f; mso-font-kerning: 12.0pt; language: ko; mso-style-textfill-type: solid; mso-style-textfill-fill-color: #5F5F5F; mso-style-textfill-fill-alpha: 100.0%;">대해 이해를 돕는 </span><span style="font-size: 10.5pt; font-family: 나눔스퀘어; mso-ascii-font-family: 나눔스퀘어; mso-fareast-font-family: 나눔스퀘어; mso-bidi-font-family: +mn-cs; mso-bidi-theme-font: minor-bidi; color: #5f5f5f; mso-font-kerning: 12.0pt; language: ko; mso-style-textfill-type: solid; mso-style-textfill-fill-color: #5F5F5F; mso-style-textfill-fill-alpha: 100.0%;">제품</span></div>\n<div class="O0" style="line-height: 150%; margin-top: 0pt; margin-bottom: 0pt; margin-left: 0.2in; text-indent: -0.2in; direction: ltr; unicode-bidi: embed; word-break: keep-all;"><span style="font-size: 10.5pt; font-family: 나눔스퀘어; mso-ascii-font-family: 나눔스퀘어; mso-fareast-font-family: 나눔스퀘어; mso-bidi-font-family: +mn-cs; mso-bidi-theme-font: minor-bidi; color: #5f5f5f; mso-font-kerning: 12.0pt; language: ko; mso-style-textfill-type: solid; mso-style-textfill-fill-color: #5F5F5F; mso-style-textfill-fill-alpha: 100.0%;">&nbsp; 카탈로그 디자인 제작</span></div>\n<div class="O0" style="line-height: 150%; margin-top: 0pt; margin-bottom: 0pt; margin-left: 0.2in; text-indent: -0.2in; direction: ltr; unicode-bidi: embed; word-break: keep-all;"><span style="font-size: 10.5pt;"><span style="mso-special-format: bullet; font-family: Arial;">&bull; </span></span><span style="font-size: 10.5pt; font-family: 나눔스퀘어; mso-ascii-font-family: 나눔스퀘어; mso-fareast-font-family: 나눔스퀘어; mso-bidi-font-family: +mn-cs; mso-bidi-theme-font: minor-bidi; color: #5f5f5f; mso-font-kerning: 12.0pt; language: ko; mso-style-textfill-type: solid; mso-style-textfill-fill-color: #5F5F5F; mso-style-textfill-fill-alpha: 100.0%;">고급 모델 포지셔닝으로 매뉴얼의 문서 레이아웃이 아닌 </span></div>\n<div class="O0" style="line-height: 150%; margin-top: 0pt; margin-bottom: 0pt; margin-left: 0.2in; text-indent: -0.2in; direction: ltr; unicode-bidi: embed; word-break: keep-all;"><span style="font-size: 10.5pt; font-family: 나눔스퀘어; mso-ascii-font-family: 나눔스퀘어; mso-fareast-font-family: 나눔스퀘어; mso-bidi-font-family: +mn-cs; mso-bidi-theme-font: minor-bidi; color: #5f5f5f; mso-font-kerning: 12.0pt; language: ko; mso-style-textfill-type: solid; mso-style-textfill-fill-color: #5F5F5F; mso-style-textfill-fill-alpha: 100.0%;">&nbsp; 디자인 요소가 반영된 제품 </span><span style="font-size: 10.5pt; font-family: 나눔스퀘어; mso-ascii-font-family: 나눔스퀘어; mso-fareast-font-family: 나눔스퀘어; mso-bidi-font-family: +mn-cs; mso-bidi-theme-font: minor-bidi; color: #5f5f5f; mso-font-kerning: 12.0pt; language: ko; mso-style-textfill-type: solid; mso-style-textfill-fill-color: #5F5F5F; mso-style-textfill-fill-alpha: 100.0%;">카탈로그 디자인 제작 </span></div>',
          logos: [1389, 0],
          date_published: '2023-10-31T04:32:16.000Z',
          main_cat: 1,
          categories: [1],
          industries: [2],
          sectors: [2],
          logoFiles: [
            {
              id: 1389,
              name: '현대엘리베이터로고.jpg',
              url: '/media/20231031/1698726621-현대엘리베이터로고.jpg',
              thumb_url:
                '/media/20231031/1698726621-현대엘리베이터로고.jpg',
              mimetype: 'image/jpeg',
              size: 3822,
              date_uploaded: '2023-10-31T04:30:21.000Z',
              uploader_id: 6,
            },
          ],
        },
        {
          id: 54,
          image_thumb_url:
            '/media/20231114/1699949599-MicrosoftTeams-image2.jpg',
          image_url:
            '/media/20231114/1699949599-MicrosoftTeams-image2.jpg',
          name: '현대자동차',
          subname: '',
          description:
            '<p style="line-height: 150%; margin-top: 0pt; margin-bottom: 0pt; margin-left: 0in; direction: ltr; unicode-bidi: embed; word-break: normal;">&nbsp;</p>\n<div style="line-height: 150%; margin-top: 0pt; margin-bottom: 0pt; margin-left: 0.2in; text-indent: -0.2in; direction: ltr; unicode-bidi: embed; word-break: normal; text-align: left;"><span style="font-size: 10.5pt;"><span style="mso-special-format: bullet; font-family: Arial;">&bull;&nbsp; &nbsp;</span></span><span style="font-size: 10.5pt; font-family: 나눔스퀘어; mso-ascii-font-family: 나눔스퀘어; mso-fareast-font-family: 나눔스퀘어; mso-bidi-font-family: +mn-cs; mso-bidi-theme-font: minor-bidi; color: #5f5f5f; mso-font-kerning: 12.0pt; language: ko; mso-style-textfill-type: solid; mso-style-textfill-fill-color: #5F5F5F; mso-style-textfill-fill-alpha: 100.0%;">사용자가 제품 구매 후 기본적인 사용법을 익히고 적절한 유지보수 방법 및 </span><span style="font-size: 10.5pt; font-family: 나눔스퀘어; mso-ascii-font-family: 나눔스퀘어; mso-fareast-font-family: 나눔스퀘어; mso-bidi-font-family: +mn-cs; mso-bidi-theme-font: minor-bidi; color: #5f5f5f; mso-font-kerning: 12.0pt; language: ko; mso-style-textfill-type: solid; mso-style-textfill-fill-color: #5F5F5F; mso-style-textfill-fill-alpha: 100.0%;">보증 내용에 대해 이해를 돕는 표준 매뉴얼 제작​</span></div>\n<p style="text-align: left;"><span style="font-size: 10.5pt; font-family: 나눔스퀘어; mso-ascii-font-family: 나눔스퀘어; mso-fareast-font-family: 나눔스퀘어; mso-bidi-font-family: +mn-cs; mso-bidi-theme-font: minor-bidi; color: #5f5f5f; mso-font-kerning: 12.0pt; language: ko; mso-style-textfill-type: solid; mso-style-textfill-fill-color: #5F5F5F; mso-style-textfill-fill-alpha: 100.0%;"><span style="font-family: Arial; text-indent: -19.2px;">&bull;&nbsp; &nbsp; </span>해외 시장 소비자를 위한 제품 매뉴얼 다국어 번역</span></p>',
          logos: [230, 1318],
          date_published: '2023-07-13T13:34:40.000Z',
          main_cat: 1,
          categories: [1],
          industries: [9],
          sectors: [1, 3],
          logoFiles: [
            {
              id: 230,
              name: 'Hyundai.png',
              url: '/media/20220527/1653632590.png',
              thumb_url: '/media/20220527/thumb-1653632590.png',
              mimetype: 'image/png',
              size: 9487,
              date_uploaded: '2022-05-26T21:23:10.000Z',
              uploader_id: 1,
            },
            {
              id: 1318,
              name: '흰색.png',
              url: '/media/20230919/1695080422-흰색.png',
              thumb_url: '/media/20230919/thumb-1695080422.jpg',
              mimetype: 'image/png',
              size: 3136,
              date_uploaded: '2023-09-18T23:40:23.000Z',
              uploader_id: 2,
            },
          ],
        },
        {
          id: 53,
          image_thumb_url: '/media/20240117/1705465904-motrex.png',
          image_url: '/media/20240117/1705465904-motrex.png',
          name: '모트렉스',
          subname: '',
          description:
            '<div style="language: en-US; line-height: 150%; margin-top: 0pt; margin-bottom: 0pt; margin-left: .2in; text-indent: -.2in; text-align: left; direction: ltr; unicode-bidi: embed; mso-line-break-override: none; word-break: normal; punctuation-wrap: hanging;">&nbsp;</div>\n<div style="language: en-US; line-height: 150%; margin-top: 0pt; margin-bottom: 0pt; margin-left: .2in; text-indent: -.2in; text-align: left; direction: ltr; unicode-bidi: embed; mso-line-break-override: none; word-break: normal; punctuation-wrap: hanging;"><span style="font-size: 10.5pt;"><span style="mso-special-format: bullet; font-family: Arial;">&bull;</span></span><span style="font-size: 10.5pt; font-family: 나눔스퀘어; mso-ascii-font-family: 나눔스퀘어; mso-fareast-font-family: 나눔스퀘어; mso-bidi-font-family: +mn-cs; mso-bidi-theme-font: minor-bidi; color: #5f5f5f; mso-font-kerning: 12.0pt; language: ko; mso-style-textfill-type: solid; mso-style-textfill-fill-color: #5F5F5F; mso-style-textfill-fill-alpha: 100.0%;">차량용 인포테인먼트 시스템 콘텐츠에 대한 다국어 번역</span></div>\n<div style="language: en-US; line-height: 150%; margin-top: 0pt; margin-bottom: 0pt; margin-left: .2in; text-indent: -.2in; text-align: left; direction: ltr; unicode-bidi: embed; mso-line-break-override: none; word-break: normal; punctuation-wrap: hanging;"><span style="font-size: 10.5pt;"><span style="mso-special-format: bullet; font-family: Arial;">&bull;</span></span><span style="font-size: 10.5pt; font-family: 나눔스퀘어; mso-ascii-font-family: 나눔스퀘어; mso-fareast-font-family: 나눔스퀘어; mso-bidi-font-family: +mn-cs; mso-bidi-theme-font: minor-bidi; color: #5f5f5f; mso-font-kerning: 12.0pt; language: ko; mso-style-textfill-type: solid; mso-style-textfill-fill-color: #5F5F5F; mso-style-textfill-fill-alpha: 100.0%;">기존 매뉴얼의 다국어 번역 및 인쇄 매뉴얼을 웹 매뉴얼로 퍼블리싱</span></div>',
          logos: [1232, 0],
          date_published: '2023-07-13T13:33:05.000Z',
          main_cat: 1,
          categories: [1],
          industries: [9],
          sectors: [7, 3],
          logoFiles: [
            {
              id: 1232,
              name: 'motrex_logo.jpg',
              url: '/media/20230713/1689255045-motrex_logo.jpg',
              thumb_url: '/media/20230713/thumb-1689255045.jpg',
              mimetype: 'image/jpeg',
              size: 50844,
              date_uploaded: '2023-07-13T13:30:45.000Z',
              uploader_id: 1,
            },
          ],
        },
        {
          id: 52,
          image_thumb_url: '/media/20230419/thumb-1681892501.jpg',
          image_url:
            '/media/20230419/1681892501-코웨이%204월%20포폴.jpg',
          name: '코웨이',
          subname: '',
          description:
            '<div style="line-height: 150%; margin-top: 0pt; margin-bottom: 0pt; margin-left: 0.2in; text-indent: -0.2in; direction: ltr; unicode-bidi: embed; word-break: keep-all;"><span style="font-size: 12pt;"><span style="mso-special-format: bullet; font-family: Arial;">&bull;</span><span style="font-family: 나눔스퀘어; color: #5f5f5f;">사용자가 제품 구매 후 기본적인 사용법을 익히고 적절한 유지보수 방법 및 보증 내용에 대해 이해를 돕는 표준 매뉴얼 제작​</span></span></div>\n<p><span style="font-size: 12pt;"> </span></p>\n<div style="line-height: 150%; margin-top: 0pt; margin-bottom: 0pt; margin-left: 0.2in; text-indent: -0.2in; direction: ltr; unicode-bidi: embed; word-break: keep-all;"><span style="font-size: 12pt;"><span style="mso-special-format: bullet; font-family: Arial;">&bull;</span><span style="font-family: 나눔스퀘어; color: #5f5f5f;">소비자들이 </span><span style="font-family: 나눔스퀘어; color: #5f5f5f;">A/S</span><span style="font-family: 나눔스퀘어; color: #5f5f5f;">를 받을 때 </span><span style="font-family: 나눔스퀘어; color: #5f5f5f;">알아두어야</span><span style="font-family: 나눔스퀘어; color: #5f5f5f;"> 할 사항들을 담은 서비스매뉴얼 제작</span></span></div>',
          logos: [1108, 0],
          date_published: '2023-04-19T08:22:27.000Z',
          main_cat: 1,
          categories: [1],
          industries: [1],
          sectors: [2, 1, 3],
          logoFiles: [
            {
              id: 1108,
              name: '코웨이 로고.jpg',
              url: '/media/20230419/1681892493-코웨이%20로고.jpg',
              thumb_url: '/media/20230419/thumb-1681892493.jpg',
              mimetype: 'image/jpeg',
              size: 117694,
              date_uploaded: '2023-04-19T08:21:33.000Z',
              uploader_id: 2,
            },
          ],
        },
        {
          id: 51,
          image_thumb_url: '/media/20230419/thumb-1681892449.jpg',
          image_url:
            '/media/20230419/1681892449-아이디스%204월포폴.jpg',
          name: 'IDIS',
          subname: '',
          description:
            '<div style="line-height: 150%; margin-top: 0pt; margin-bottom: 0pt; margin-left: 0.2in; text-indent: -0.2in; direction: ltr; unicode-bidi: embed; word-break: keep-all;"><span style="font-size: 12pt;"><span style="mso-special-format: bullet; font-family: Arial;">&bull;</span><span style="font-family: 나눔스퀘어; color: #5f5f5f;">사용자가 제품 구매 후 기본적인 사용법을 익히고 적절한 유지보수 방법 및 보증 내용에 대해 이해를 돕는 표준 매뉴얼 제작​</span></span></div>\n<p><span style="font-size: 12pt;"> </span></p>\n<div style="line-height: 150%; margin-top: 0pt; margin-bottom: 0pt; margin-left: 0.2in; text-indent: -0.2in; direction: ltr; unicode-bidi: embed; word-break: keep-all;"><span style="font-size: 12pt;"><span style="mso-special-format: bullet; font-family: Arial;">&bull;</span><span style="font-family: 나눔스퀘어; color: #5f5f5f;">소비자들이 </span><span style="font-family: 나눔스퀘어; color: #5f5f5f;">A/S</span><span style="font-family: 나눔스퀘어; color: #5f5f5f;">를 받을 때 </span><span style="font-family: 나눔스퀘어; color: #5f5f5f;">알아두어야</span><span style="font-family: 나눔스퀘어; color: #5f5f5f;"> 할 사항들을 담은 서비스매뉴얼 제작</span></span></div>',
          logos: [1106, 0],
          date_published: '2023-04-19T08:20:53.000Z',
          main_cat: 1,
          categories: [1],
          industries: [1],
          sectors: [1, 3],
          logoFiles: [
            {
              id: 1106,
              name: '아이디스 로고.jpg',
              url: '/media/20230419/1681892444-아이디스%20로고.jpg',
              thumb_url:
                '/media/20230419/1681892444-아이디스%20로고.jpg',
              mimetype: 'image/jpeg',
              size: 6948,
              date_uploaded: '2023-04-19T08:20:44.000Z',
              uploader_id: 2,
            },
          ],
        },
        {
          id: 50,
          image_thumb_url: '/media/20230419/thumb-1681891854.jpg',
          image_url: '/media/20230419/1681891854-HP프린팅코리아.jpg',
          name: 'HP프린팅코리아',
          subname: '',
          description:
            '<p style="line-height: 150%; margin-top: 0pt; margin-bottom: 0pt; margin-left: 0in; direction: ltr; unicode-bidi: embed; word-break: keep-all;"><span style="font-size: 12pt;"><span style="mso-special-format: bullet; font-family: Arial;">&bull;</span><span style="font-family: 나눔스퀘어; color: #5f5f5f;">프린터</span><span style="font-family: 나눔스퀘어; color: #5f5f5f;">, </span><span style="font-family: 나눔스퀘어; color: #5f5f5f;">복합기의 사용방법</span><span style="font-family: 나눔스퀘어; color: #5f5f5f;">, </span><span style="font-family: 나눔스퀘어; color: #5f5f5f;">설치방법</span><span style="font-family: 나눔스퀘어; color: #5f5f5f;">, </span><span style="font-family: 나눔스퀘어; color: #5f5f5f;">오류해결 등 제품에 대해 이해를 돕는 매뉴얼 제작</span></span></p>',
          logos: [1112, 0],
          date_published: '2023-04-19T08:11:30.000Z',
          main_cat: 1,
          categories: [1],
          industries: [1],
          sectors: [1, 3],
          logoFiles: [
            {
              id: 1112,
              name: 'shutterstock_265456295.jpg',
              url: '/media/20230420/1681955403-shutterstock_265456295.jpg',
              thumb_url: '/media/20230420/thumb-1681955403.jpg',
              mimetype: 'image/jpeg',
              size: 3476830,
              date_uploaded: '2023-04-20T01:50:04.000Z',
              uploader_id: 2,
            },
          ],
        },
        {
          id: 49,
          image_thumb_url:
            '/media/20230120/thumb-1674176023-lgensol.jpg',
          image_url: '/media/20230120/1674176023-lgensol.jpg',
          name: 'LG 에너지 솔루션',
          subname: '',
          description:
            "<div style=\"language: ko; line-height: 150%; margin-top: 0pt; margin-bottom: 0pt; margin-left: .2in; text-indent: -.2in; text-align: left; direction: ltr; unicode-bidi: embed; mso-line-break-override: none; word-break: break-hangul; punctuation-wrap: hanging;\">\n<div class=\"client-description-head animate__animated animate__fadeInDown animate__delay-1s\" style=\"box-sizing: border-box; animation-duration: var(--animate-duration); animation-fill-mode: both; animation-name: fadeInDown; animation-delay: var(--animate-delay); color: #959595; font-weight: bold; font-size: 18px; margin-top: 24px; font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, 'Helvetica Neue', Arial, 'Noto Sans', 'Liberation Sans', sans-serif, 'Apple Color Emoji', 'Segoe UI Emoji', 'Segoe UI Symbol', 'Noto Color Emoji'; text-indent: 0px; background-color: #ffffff;\" data-v-3df1607e=\"\">&nbsp;</div>\n<div class=\"client-description animate__animated animate__fadeInDown animate__delay-1s\" style=\"box-sizing: border-box; animation-duration: var(--animate-duration); animation-fill-mode: both; animation-name: fadeInDown; animation-delay: var(--animate-delay); color: #959595; font-size: 16px; font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, 'Helvetica Neue', Arial, 'Noto Sans', 'Liberation Sans', sans-serif, 'Apple Color Emoji', 'Segoe UI Emoji', 'Segoe UI Symbol', 'Noto Color Emoji'; text-indent: 0px; background-color: #ffffff;\" data-v-3df1607e=\"\">\n<ul style=\"box-sizing: border-box; margin-bottom: 1rem; margin-top: 0px; padding-left: 24px;\">\n<li style=\"box-sizing: border-box;\"><span style=\"font-size: 12pt;\">교육, 훈련, 테스트를 모두 제공하는 가상 훈련 시뮬레이터</span></li>\n<li style=\"box-sizing: border-box;\"><span style=\"font-size: 12pt;\">해외 제조 공장에서 신규 인력에 대한 공정 숙련도 향상 및 제조 물량률 저감을 기여하기 위한 시뮬레이터 개발</span></li>\n</ul>\n</div>\n</div>",
          logos: [1011, 0],
          date_published: '2023-01-20T01:02:34.000Z',
          main_cat: 4,
          categories: [4],
          industries: [2],
          sectors: [10],
          logoFiles: [
            {
              id: 1011,
              name: '1674187482-82939_63352_2954.png',
              url: '/media/20230120/1674187482-82939_63352_2954.png',
              thumb_url:
                '/media/20230120/thumb-1674187482-82939_63352_2954.png',
              mimetype: 'image/png',
              size: 24939,
              date_uploaded: '2023-01-20T04:04:42.000Z',
              uploader_id: 2,
            },
          ],
        },
        {
          id: 47,
          image_thumb_url: '/media/20221111/thumb-1668135637.jpg',
          image_url: '/media/20221111/1668135637.jpg',
          name: '한화 큐셀',
          subname: '',
          description:
            '<p style="language: ko; line-height: 150%; margin-top: 0pt; margin-bottom: 0pt; margin-left: 0in; text-align: left; direction: ltr; unicode-bidi: embed; mso-line-break-override: none; word-break: keep-all; punctuation-wrap: hanging;"><span style="font-size: 12pt;"><span style="text-indent: -0.2in;"><span style="mso-special-format: bullet; font-family: Arial;">&bull;</span></span><span style="text-indent: -0.2in; font-family: 나눔스퀘어; color: #595959;">태양광 모듈과 연결되는 배터리 및 인버터와 관련된 제품에 대한 설치 매뉴얼 제작​</span></span></p>\n<div style="language: ko; line-height: 150%; margin-top: 0pt; margin-bottom: 0pt; margin-left: .2in; text-indent: -.2in; text-align: left; direction: ltr; unicode-bidi: embed; mso-line-break-override: none; word-break: keep-all; punctuation-wrap: hanging;"><span style="font-size: 12pt;"><span style="mso-special-format: bullet; font-family: Arial;">&bull;</span><span style="font-family: 나눔스퀘어; color: #595959;">고객사의 </span><span style="font-family: 나눔스퀘어; color: #595959;">CI</span><span style="font-family: 나눔스퀘어; color: #595959;">에 맞춰 템플릿 수정 및 개발</span></span></div>',
          logos: [872, 0],
          date_published: '2022-11-10T18:00:45.000Z',
          main_cat: 1,
          categories: [1],
          industries: [2],
          sectors: [3, 1],
          logoFiles: [
            {
              id: 872,
              name: 'ê·¸ë¦¼7.jpg',
              url: '/media/20221111/1668135628.jpg',
              thumb_url: '/media/20221111/thumb-1668135628.jpg',
              mimetype: 'image/jpeg',
              size: 22241,
              date_uploaded: '2022-11-10T18:00:28.000Z',
              uploader_id: 2,
            },
          ],
        },
        {
          id: 46,
          image_thumb_url: '/media/20221106/thumb-1667777055.jpg',
          image_url: '/media/20221106/1667777055.jpg',
          name: 'Hyundai',
          subname: '',
          description:
            '<div style="language: ko; margin-top: 0pt; margin-bottom: 0pt; margin-left: .31in; text-indent: -.31in; text-align: left; direction: ltr; unicode-bidi: embed; mso-line-break-override: none; word-break: break-hangul; punctuation-wrap: hanging;"><span style="font-size: 12pt;"><span style="mso-special-format: bullet; font-family: Arial;">&bull;</span><span style="font-family: 나눔스퀘어; color: #767171;">오너스매뉴얼</span><span style="font-family: 나눔스퀘어; color: #767171;"> </span><span style="font-family: 나눔스퀘어; color: #767171;">XML </span><span style="font-family: 나눔스퀘어; color: #767171;">제작 및 편집 시스템</span></span></div>\n<div style="language: ko; margin-top: 0pt; margin-bottom: 0pt; margin-left: .31in; text-indent: -.31in; text-align: left; direction: ltr; unicode-bidi: embed; mso-line-break-override: none; word-break: break-hangul; punctuation-wrap: hanging;"><span style="font-size: 12pt;"><span style="mso-special-format: bullet; font-family: Arial;">&bull;</span><span style="font-family: 나눔스퀘어; color: #767171;">저작</span><span style="font-family: 나눔스퀘어; color: #767171;">, </span><span style="font-family: 나눔스퀘어; color: #767171;">도안</span><span style="font-family: 나눔스퀘어; color: #767171;">, </span><span style="font-family: 나눔스퀘어; color: #767171;">감수</span><span style="font-family: 나눔스퀘어; color: #767171;">, </span><span style="font-family: 나눔스퀘어; color: #767171;">출판 협업 지원</span></span></div>\n<div style="language: ko; margin-top: 0pt; margin-bottom: 0pt; margin-left: .31in; text-indent: -.31in; text-align: left; direction: ltr; unicode-bidi: embed; mso-line-break-override: none; word-break: break-hangul; punctuation-wrap: hanging;"><span style="font-size: 12pt;"><span style="mso-special-format: bullet; font-family: Arial;">&bull;</span><span style="font-family: 나눔스퀘어; color: #767171;">XML, </span><span style="font-family: 나눔스퀘어; color: #767171;">그래픽</span><span style="font-family: 나눔스퀘어; color: #767171;"> </span><span style="font-family: 나눔스퀘어; color: #767171;">등</span><span style="font-family: 나눔스퀘어; color: #767171;"> </span><span style="font-family: 나눔스퀘어; color: #767171;">데이터 버전 및 형상 관리</span></span></div>\n<div style="language: ko; margin-top: 0pt; margin-bottom: 0pt; margin-left: .31in; text-indent: -.31in; text-align: left; direction: ltr; unicode-bidi: embed; mso-line-break-override: none; word-break: break-hangul; punctuation-wrap: hanging;"><span style="font-size: 12pt;"><span style="mso-special-format: bullet; font-family: Arial;">&bull;</span><span style="font-family: 나눔스퀘어; color: #767171;">웹브라우저</span><span style="font-family: 나눔스퀘어; color: #767171;"> 기반 </span><span style="font-family: 나눔스퀘어; color: #767171;">XML </span><span style="font-family: 나눔스퀘어; color: #767171;">문서 편집 및 </span><span style="font-family: 나눔스퀘어; color: #767171;">FrameMaker </span><span style="font-family: 나눔스퀘어; color: #767171;">연동 지원</span></span></div>\n<div style="language: ko; margin-top: 0pt; margin-bottom: 0pt; margin-left: .31in; text-indent: -.31in; text-align: left; direction: ltr; unicode-bidi: embed; mso-line-break-override: none; word-break: break-hangul; punctuation-wrap: hanging;"><span style="font-size: 12pt;"><span style="mso-special-format: bullet; font-family: Arial;">&bull;</span><span style="font-family: 나눔스퀘어; color: #767171;">PDF, </span><span style="font-family: 나눔스퀘어; color: #767171;">WebHelp</span><span style="font-family: 나눔스퀘어; color: #767171;"> </span><span style="font-family: 나눔스퀘어; color: #767171;">포맷으로 자동 퍼블리싱</span></span></div>\n<div style="language: ko; margin-top: 0pt; margin-bottom: 0pt; margin-left: .31in; text-indent: -.31in; text-align: left; direction: ltr; unicode-bidi: embed; mso-line-break-override: none; word-break: break-hangul; punctuation-wrap: hanging;"><span style="font-size: 12pt;"><span style="mso-special-format: bullet; font-family: Arial;">&bull;</span><span style="font-family: 나눔스퀘어; color: #767171;">사용자 권한에 따른 파일 및 폴더 액세스 관리</span></span></div>\n<div style="language: ko; margin-top: 0pt; margin-bottom: 0pt; margin-left: .31in; text-indent: -.31in; text-align: left; direction: ltr; unicode-bidi: embed; mso-line-break-override: none; word-break: break-hangul; punctuation-wrap: hanging;"><span style="font-size: 12pt;"><span style="mso-special-format: bullet; font-family: Arial;">&bull;</span><span style="font-family: 나눔스퀘어; color: #767171;">프로젝트 스케줄 관리</span></span></div>',
          logos: [230, 0],
          date_published: '2022-11-06T14:27:42.000Z',
          main_cat: 3,
          categories: [3],
          industries: [9],
          sectors: [6],
          logoFiles: [
            {
              id: 230,
              name: 'Hyundai.png',
              url: '/media/20220527/1653632590.png',
              thumb_url: '/media/20220527/thumb-1653632590.png',
              mimetype: 'image/png',
              size: 9487,
              date_uploaded: '2022-05-26T21:23:10.000Z',
              uploader_id: 1,
            },
          ],
        },
        {
          id: 45,
          image_thumb_url: '/media/20230713/thumb-1689254596.jpg',
          image_url: '/media/20230713/1689254596-develon%201.jpg',
          name: 'HD현대인프라코어',
          subname: '',
          description:
            '<div style="language: ko; margin-top: 0pt; margin-bottom: 0pt; margin-left: .31in; text-indent: -.31in; text-align: left; direction: ltr; unicode-bidi: embed; mso-line-break-override: none; word-break: break-hangul; punctuation-wrap: hanging;"><span style="font-size: 12pt;"><span style="mso-special-format: bullet; font-family: Arial;">&bull;</span><span style="font-family: 나눔스퀘어; color: #767171;">운영 및 정비 매뉴얼을 비롯한 각종 기술 문서 배포 시스템 </span></span></div>\n<div style="language: ko; margin-top: 0pt; margin-bottom: 0pt; margin-left: .31in; text-indent: -.31in; text-align: left; direction: ltr; unicode-bidi: embed; mso-line-break-override: none; word-break: break-hangul; punctuation-wrap: hanging;"><span style="font-size: 12pt;"><span style="mso-special-format: bullet; font-family: Arial;">&bull;</span><span style="font-family: 나눔스퀘어; color: #767171;">XML </span><span style="font-family: 나눔스퀘어; color: #767171;">기반으로 </span><span style="font-family: 나눔스퀘어; color: #767171;">PDF, </span><span style="font-family: 나눔스퀘어; color: #767171;">WebHelp</span><span style="font-family: 나눔스퀘어; color: #767171;"> </span><span style="font-family: 나눔스퀘어; color: #767171;">포맷으로 자동 변환</span></span></div>\n<div style="language: ko; margin-top: 0pt; margin-bottom: 0pt; margin-left: .31in; text-indent: -.31in; text-align: left; direction: ltr; unicode-bidi: embed; mso-line-break-override: none; word-break: break-hangul; punctuation-wrap: hanging;"><span style="font-size: 12pt;"><span style="mso-special-format: bullet; font-family: Arial;">&bull;</span><span style="font-family: 나눔스퀘어; color: #767171;">사용자 가입</span><span style="font-family: 나눔스퀘어; color: #767171;">, </span><span style="font-family: 나눔스퀘어; color: #767171;">유형별 문서 관리</span><span style="font-family: 나눔스퀘어; color: #767171;">, </span><span style="font-family: 나눔스퀘어; color: #767171;">커뮤니티 관리</span><span style="font-family: 나눔스퀘어; color: #767171;">, </span><span style="font-family: 나눔스퀘어; color: #767171;">통계 관리 기능</span></span></div>\n<div style="language: ko; margin-top: 0pt; margin-bottom: 0pt; margin-left: .31in; text-indent: -.31in; text-align: left; direction: ltr; unicode-bidi: embed; mso-line-break-override: none; word-break: break-hangul; punctuation-wrap: hanging;"><span style="font-size: 12pt;"><span style="mso-special-format: bullet; font-family: Arial;">&bull;</span><span style="font-family: 나눔스퀘어; color: #767171;">콘텐츠 자동 분류</span><span style="font-family: 나눔스퀘어; color: #767171;">, </span><span style="font-family: 나눔스퀘어; color: #767171;">문서 버전 관리</span><span style="font-family: 나눔스퀘어; color: #767171;">, </span><span style="font-family: 나눔스퀘어; color: #767171;">통합 검색 구현</span></span></div>\n<div style="language: ko; margin-top: 0pt; margin-bottom: 0pt; margin-left: .31in; text-indent: -.31in; text-align: left; direction: ltr; unicode-bidi: embed; mso-line-break-override: none; word-break: break-hangul; punctuation-wrap: hanging;"><span style="font-size: 12pt;"><span style="mso-special-format: bullet; font-family: Arial;">&bull;</span><span style="font-family: 나눔스퀘어; color: #767171;">웹</span><span style="font-family: 나눔스퀘어; color: #767171;">, </span><span style="font-family: 나눔스퀘어; color: #767171;">모바일 앱 및 </span><span style="font-family: 나눔스퀘어; color: #767171;">오프라인 서비스를 위한 탐색 및 검색 기능 지원</span></span></div>\n<div style="language: ko; margin-top: 0pt; margin-bottom: 0pt; margin-left: .31in; text-indent: -.31in; text-align: left; direction: ltr; unicode-bidi: embed; mso-line-break-override: none; word-break: break-hangul; punctuation-wrap: hanging;"><span style="font-size: 12pt;"><span style="mso-special-format: bullet; font-family: Arial;">&bull;</span><span style="font-family: 나눔스퀘어; color: #767171;">트래픽</span><span style="font-family: 나눔스퀘어; color: #767171;">, </span><span style="font-family: 나눔스퀘어; color: #767171;">검색</span><span style="font-family: 나눔스퀘어; color: #767171;">, </span><span style="font-family: 나눔스퀘어; color: #767171;">피드백 데이터 기분 사용성 분석 제공</span><span style="font-family: 나눔스퀘어; color: #767171;">, </span><span style="font-family: 나눔스퀘어; color: #767171;">이를 통한 의사 결정 및 컨텐츠 인사이트 확보</span></span></div>',
          logos: [1228, 0],
          date_published: '2022-11-06T14:22:05.000Z',
          main_cat: 3,
          categories: [3],
          industries: [2],
          sectors: [6],
          logoFiles: [
            {
              id: 1228,
              name: 'HD현대인프라코어_국문.jpg',
              url: '/media/20230713/1689254486-HD현대인프라코어_국문.jpg',
              thumb_url: '/media/20230713/thumb-1689254486.jpg',
              mimetype: 'image/jpeg',
              size: 256883,
              date_uploaded: '2023-07-13T13:21:26.000Z',
              uploader_id: 1,
            },
          ],
        },
        {
          id: 44,
          image_thumb_url: '/media/20230713/thumb-1689254516.jpg',
          image_url: '/media/20230713/1689254516-develon%202.jpg',
          name: 'HD현대인프라코어',
          subname: '',
          description:
            '<div style="language: ko; margin-top: 0pt; margin-bottom: 0pt; margin-left: .31in; text-indent: -.31in; text-align: left; direction: ltr; unicode-bidi: embed; mso-line-break-override: none; word-break: break-hangul; punctuation-wrap: hanging;"><span style="font-size: 12pt;"><span style="mso-special-format: bullet; font-family: Arial;">&bull;</span><span style="font-family: \'맑은 고딕\'; color: #767171;">운영 및 정비 매뉴얼 </span><span style="font-family: \'맑은 고딕\'; color: #767171;">XML </span><span style="font-family: \'맑은 고딕\'; color: #767171;">제작 및 편집 시스템</span></span></div>\n<div style="language: ko; margin-top: 0pt; margin-bottom: 0pt; margin-left: .31in; text-indent: -.31in; text-align: left; direction: ltr; unicode-bidi: embed; mso-line-break-override: none; word-break: break-hangul; punctuation-wrap: hanging;"><span style="font-size: 12pt;"><span style="mso-special-format: bullet; font-family: Arial;">&bull;</span><span style="font-family: \'맑은 고딕\'; color: #767171;">운영 및 정비 매뉴얼 </span><span style="font-family: \'맑은 고딕\'; color: #767171;">XML </span><span style="font-family: \'맑은 고딕\'; color: #767171;">데이터 버전 관리</span></span></div>\n<div style="language: ko; margin-top: 0pt; margin-bottom: 0pt; margin-left: .31in; text-indent: -.31in; text-align: left; direction: ltr; unicode-bidi: embed; mso-line-break-override: none; word-break: break-hangul; punctuation-wrap: hanging;"><span style="font-size: 12pt;"><span style="mso-special-format: bullet; font-family: Arial;">&bull;</span><span style="font-family: \'맑은 고딕\'; color: #767171;">그룹</span><span style="font-family: \'맑은 고딕\'; color: #767171;">/</span><span style="font-family: \'맑은 고딕\'; color: #767171;">사용자 권한에 따른 파일 및 폴더 액세스 관리를 통한 부서 및 지사 접근 권한 통제</span></span></div>\n<div style="language: ko; margin-top: 0pt; margin-bottom: 0pt; margin-left: .31in; text-indent: -.31in; text-align: left; direction: ltr; unicode-bidi: embed; mso-line-break-override: none; word-break: break-hangul; punctuation-wrap: hanging;"><span style="font-size: 12pt;"><span style="mso-special-format: bullet; font-family: Arial;">&bull;</span><span style="font-family: \'맑은 고딕\'; color: #767171;">기존 </span><span style="font-family: \'맑은 고딕\'; color: #767171;">XML </span><span style="font-family: \'맑은 고딕\'; color: #767171;">데이터를 활용하여 신규 또는 파생 매뉴얼 제작을 지원하는 </span><span style="font-family: \'맑은 고딕\'; color: #767171;">Map Collection </span><span style="font-family: \'맑은 고딕\'; color: #767171;">기능</span></span></div>\n<div style="language: ko; margin-top: 0pt; margin-bottom: 0pt; margin-left: .31in; text-indent: -.31in; text-align: left; direction: ltr; unicode-bidi: embed; mso-line-break-override: none; word-break: break-hangul; punctuation-wrap: hanging;"><span style="font-size: 12pt;"><span style="mso-special-format: bullet; font-family: Arial;">&bull;</span><span style="font-family: \'맑은 고딕\'; color: #767171;">파일</span><span style="font-family: \'맑은 고딕\'; color: #767171;">/</span><span style="font-family: \'맑은 고딕\'; color: #767171;">폴더 및 파일 내 텍스트까지 검색하는 </span><span style="font-family: \'맑은 고딕\'; color: #767171;">Full-Text </span><span style="font-family: \'맑은 고딕\'; color: #767171;">검색 지원</span></span></div>\n<div style="language: ko; margin-top: 0pt; margin-bottom: 0pt; margin-left: .31in; text-indent: -.31in; text-align: left; direction: ltr; unicode-bidi: embed; mso-line-break-override: none; word-break: break-hangul; punctuation-wrap: hanging;"><span style="font-size: 12pt;"><span style="mso-special-format: bullet; font-family: Arial;">&bull;</span><span style="font-family: \'맑은 고딕\'; color: #767171;">다국어 번역 워크플로우 지원</span></span></div>',
          logos: [1228, 0],
          date_published: '2022-11-06T14:20:58.000Z',
          main_cat: 3,
          categories: [3],
          industries: [2],
          sectors: [6],
          logoFiles: [
            {
              id: 1228,
              name: 'HD현대인프라코어_국문.jpg',
              url: '/media/20230713/1689254486-HD현대인프라코어_국문.jpg',
              thumb_url: '/media/20230713/thumb-1689254486.jpg',
              mimetype: 'image/jpeg',
              size: 256883,
              date_uploaded: '2023-07-13T13:21:26.000Z',
              uploader_id: 1,
            },
          ],
        },
        {
          id: 43,
          image_thumb_url: '/media/20221106/thumb-1667776531.jpg',
          image_url: '/media/20221106/1667776531.jpg',
          name: 'DB하이텍',
          subname: '',
          description:
            '<div style="language: ko; margin-top: 0pt; margin-bottom: 0pt; margin-left: .31in; text-indent: -.31in; text-align: left; direction: ltr; unicode-bidi: embed; mso-line-break-override: none; word-break: break-hangul; punctuation-wrap: hanging;"><span style="font-size: 12pt;"><span style="mso-special-format: bullet; font-family: Arial;">&bull;</span><span style="font-family: \'맑은 고딕\'; color: #767171;">MS</span><span style="font-family: \'맑은 고딕\'; color: #767171;">워드 파일 형식의 유형별 문서 템플릿 정형화로 다양한 사용자가 표준 템플릿을 바탕으로 문서 작성</span></span></div>\n<div style="language: ko; margin-top: 0pt; margin-bottom: 0pt; margin-left: .31in; text-indent: -.31in; text-align: left; direction: ltr; unicode-bidi: embed; mso-line-break-override: none; word-break: break-hangul; punctuation-wrap: hanging;"><span style="font-size: 12pt;"><span style="mso-special-format: bullet; font-family: Arial;">&bull;</span><span style="font-family: \'맑은 고딕\'; color: #767171;">파일 체크아웃</span><span style="font-family: \'맑은 고딕\'; color: #767171;">/</span><span style="font-family: \'맑은 고딕\'; color: #767171;">인 협업 및 버전 관리</span></span></div>\n<div style="language: ko; margin-top: 0pt; margin-bottom: 0pt; margin-left: .31in; text-indent: -.31in; text-align: left; direction: ltr; unicode-bidi: embed; mso-line-break-override: none; word-break: break-hangul; punctuation-wrap: hanging;"><span style="font-size: 12pt;"><span style="mso-special-format: bullet; font-family: Arial;">&bull;</span><span style="font-family: \'맑은 고딕\'; color: #767171;">챕터</span><span style="font-family: \'맑은 고딕\'; color: #767171;">, </span><span style="font-family: \'맑은 고딕\'; color: #767171;">섹션 등 특정 콘텐츠 단위 모듈화</span><span style="font-family: \'맑은 고딕\'; color: #767171;">, </span><span style="font-family: \'맑은 고딕\'; color: #767171;">단위 모듈 </span><span style="font-family: \'맑은 고딕\'; color: #767171;">MS</span><span style="font-family: \'맑은 고딕\'; color: #767171;">워드 파일을 하나의 문서로 합치는 퍼블리싱 기능 제공</span></span></div>\n<div style="language: ko; margin-top: 0pt; margin-bottom: 0pt; margin-left: .31in; text-indent: -.31in; text-align: left; direction: ltr; unicode-bidi: embed; mso-line-break-override: none; word-break: break-hangul; punctuation-wrap: hanging;"><span style="font-size: 12pt;"><span style="mso-special-format: bullet; font-family: Arial;">&bull;</span><span style="font-family: \'맑은 고딕\'; color: #767171;">사용자 권한 관리를 통한 폴더</span><span style="font-family: \'맑은 고딕\'; color: #767171;">/</span><span style="font-family: \'맑은 고딕\'; color: #767171;">파일 액세스 권한 통제</span></span></div>\n<div style="language: ko; margin-top: 0pt; margin-bottom: 0pt; margin-left: .31in; text-indent: -.31in; text-align: left; direction: ltr; unicode-bidi: embed; mso-line-break-override: none; word-break: break-hangul; punctuation-wrap: hanging;"><span style="font-size: 12pt;"><span style="mso-special-format: bullet; font-family: Arial;">&bull;</span><span style="font-family: \'맑은 고딕\'; color: #767171;">문서 내 텍스트까지 검색 가능한 강력한 검색 기능</span></span></div>\n<div style="language: ko; margin-top: 0pt; margin-bottom: 0pt; margin-left: .31in; text-indent: -.31in; text-align: left; direction: ltr; unicode-bidi: embed; mso-line-break-override: none; word-break: break-hangul; punctuation-wrap: hanging;"><span style="font-size: 12pt;"><span style="mso-special-format: bullet; font-family: Arial;">&bull;</span><span style="font-family: \'맑은 고딕\'; color: #767171;">사용자 환경에 따른 커스터마이즈 제공</span></span></div>',
          logos: [844, 0],
          date_published: '2022-11-06T14:16:29.000Z',
          main_cat: 3,
          categories: [3],
          industries: [2],
          sectors: [6],
          logoFiles: [
            {
              id: 844,
              name: 'ê·¸ë¦¼4.jpg',
              url: '/media/20221106/1667776526.jpg',
              thumb_url: '/media/20221106/1667776526.jpg',
              mimetype: 'image/jpeg',
              size: 7440,
              date_uploaded: '2022-11-06T14:15:26.000Z',
              uploader_id: 2,
            },
          ],
        },
        {
          id: 42,
          image_thumb_url: '/media/20221106/thumb-1667776368.jpg',
          image_url: '/media/20221106/1667776368.jpg',
          name: 'PASECO',
          subname: '',
          description:
            '<div style="language: ko; line-height: 150%; margin-top: 0pt; margin-bottom: 0pt; margin-left: .2in; text-indent: -.2in; text-align: left; direction: ltr; unicode-bidi: embed; mso-line-break-override: none; word-break: keep-all; punctuation-wrap: hanging;"><span style="font-size: 12pt;"><span style="mso-special-format: bullet; font-family: Arial;">&bull;</span><span style="font-family: 나눔스퀘어; color: #5f5f5f;">창문형에어컨의</span><span style="font-family: 나눔스퀘어; color: #5f5f5f;"> 설명서</span><span style="font-family: 나눔스퀘어; color: #5f5f5f;">, </span><span style="font-family: 나눔스퀘어; color: #5f5f5f;">설치공사매뉴얼</span><span style="font-family: 나눔스퀘어; color: #5f5f5f;">, </span><span style="font-family: 나눔스퀘어; color: #5f5f5f;">박스</span><span style="font-family: 나눔스퀘어; color: #5f5f5f;">, </span><span style="font-family: 나눔스퀘어; color: #5f5f5f;">카다로그</span><span style="font-family: 나눔스퀘어; color: #5f5f5f;"> 등의 다국어 번역</span></span></div>',
          logos: [842, 0],
          date_published: '2022-11-06T14:13:11.000Z',
          main_cat: 2,
          categories: [2],
          industries: [1],
          sectors: [3],
          logoFiles: [
            {
              id: 842,
              name: 'ê·¸ë¦¼3.jpg',
              url: '/media/20221106/1667776363.jpg',
              thumb_url: '/media/20221106/1667776363.jpg',
              mimetype: 'image/jpeg',
              size: 4872,
              date_uploaded: '2022-11-06T14:12:43.000Z',
              uploader_id: 2,
            },
          ],
        },
        {
          id: 41,
          image_thumb_url: '/media/20221106/thumb-1667776274.jpg',
          image_url: '/media/20221106/1667776274.jpg',
          name: 'Hyundai Movex',
          subname: '',
          description:
            '<div style="language: ko; line-height: 150%; margin-top: 0pt; margin-bottom: 0pt; margin-left: .2in; text-indent: -.2in; text-align: left; direction: ltr; unicode-bidi: embed; mso-line-break-override: none; word-break: keep-all; punctuation-wrap: hanging;"><span style="font-size: 12pt;"><span style="mso-special-format: bullet; font-family: Arial;">&bull;</span><span style="font-family: 나눔스퀘어; color: #5f5f5f;">물류자동화시스템의</span><span style="font-family: 나눔스퀘어; color: #5f5f5f;"> 운영매뉴얼과 유지보수매뉴얼 다국어 번역</span></span></div>',
          logos: [840, 0],
          date_published: '2022-11-06T14:11:32.000Z',
          main_cat: 2,
          categories: [2],
          industries: [2],
          sectors: [3],
          logoFiles: [
            {
              id: 840,
              name: 'ê·¸ë¦¼2.jpg',
              url: '/media/20221106/1667776266.jpg',
              thumb_url: '/media/20221106/1667776266.jpg',
              mimetype: 'image/jpeg',
              size: 8948,
              date_uploaded: '2022-11-06T14:11:06.000Z',
              uploader_id: 2,
            },
          ],
        },
        {
          id: 40,
          image_thumb_url: '/media/20221102/thumb-1667431927.jpg',
          image_url: '/media/20221102/1667431927.jpg',
          name: 'Bankware Global',
          subname: '',
          description:
            '<p style="language: ko; line-height: 150%; margin-top: 0pt; margin-bottom: 0pt; margin-left: 0in; text-align: left; direction: ltr; unicode-bidi: embed; mso-line-break-override: none; word-break: keep-all; punctuation-wrap: hanging;"><span style="font-size: 12pt;"><span style="mso-special-format: bullet; font-family: Arial;">&bull;</span><span style="font-family: 나눔스퀘어; color: #5f5f5f;">금융상품시스템으로 대외기관</span><span style="font-family: 나눔스퀘어; color: #5f5f5f;">/</span><span style="font-family: 나눔스퀘어; color: #5f5f5f;">내부시스템</span><span style="font-family: 나눔스퀘어; color: #5f5f5f;">/</span><span style="font-family: 나눔스퀘어; color: #5f5f5f;">채널시스템</span><span style="font-family: 나눔스퀘어; color: #5f5f5f;">(</span><span style="font-family: 나눔스퀘어; color: #5f5f5f;">단말</span><span style="font-family: 나눔스퀘어; color: #5f5f5f;">)</span><span style="font-family: 나눔스퀘어; color: #5f5f5f;">을 연계하고</span><span style="font-family: 나눔스퀘어; color: #5f5f5f;">, </span><span style="font-family: 나눔스퀘어; color: #5f5f5f;">각 기관</span><span style="font-family: 나눔스퀘어; color: #5f5f5f;">/</span><span style="font-family: 나눔스퀘어; color: #5f5f5f;">시스템에서 발생되는 인터페이스를 처리하는 </span><span style="font-family: 나눔스퀘어; color: #5f5f5f;">BXI </span><span style="font-family: 나눔스퀘어; color: #5f5f5f;">솔루션의 매뉴얼 번역</span></span></p>',
          logos: [839, 0],
          date_published: '2022-11-06T14:09:40.000Z',
          main_cat: 2,
          categories: [2],
          industries: [4],
          sectors: [3],
          logoFiles: [
            {
              id: 839,
              name: '1667431917.jpg',
              url: '/media/20221104/1667548722.jpg',
              thumb_url: '/media/20221104/1667548722.jpg',
              mimetype: 'image/jpeg',
              size: 2335,
              date_uploaded: '2022-11-03T22:58:42.000Z',
              uploader_id: 1,
            },
          ],
        },
        {
          id: 38,
          image_thumb_url: '/media/20220510/thumb-1652168580.jpg',
          image_url: '/media/20220510/1652168580.jpg',
          name: 'Samsung',
          subname: ' ',
          description:
            '<ul>\n<li><strong>삼성전자 &ndash; 네트워크 장비 매뉴얼 온라인 콘텐츠 변환</strong></li>\n<li><strong>MS Word -&gt;</strong> Web Manual 변환 도구</li>\n<li>HTML5, CSS3, JS 표준 적용</li>\n<li><span class="TextRun SCXP245900678 BCX9" lang="KO-KR" style="place-content: normal; place-items: normal; place-self: auto; alignment-baseline: auto; animation: 0s ease 0s 1 normal none running none; appearance: none; backdrop-filter: none; backface-visibility: visible; background-image: none; background-position: 0% 0%; background-size: auto; background-repeat: repeat; background-attachment: scroll; background-origin: padding-box; background-clip: border-box; background-blend-mode: normal; baseline-shift: 0px; block-size: auto; border-block: 0px none #5f5f5f; border: 0px none #5f5f5f; border-radius: 0px; border-collapse: separate; border-inline: 0px none #5f5f5f; inset: auto; box-shadow: none; box-sizing: content-box; break-after: auto; break-before: auto; break-inside: auto; buffered-rendering: auto; caption-side: top; caret-color: #5f5f5f; clear: none; clip: auto; clip-path: none; clip-rule: nonzero; color: #5f5f5f; color-interpolation: srgb; color-interpolation-filters: linearrgb; color-rendering: auto; columns: auto auto; gap: normal; column-rule: 0px none #5f5f5f; column-span: none; content: normal; cursor: text; cx: 0px; cy: 0px; d: none; direction: ltr; display: inline; dominant-baseline: auto; empty-cells: show; fill: #000000; fill-opacity: 1; fill-rule: nonzero; filter: none; flex: 0 1 auto; flex-flow: row nowrap; float: none; flood-color: #000000; flood-opacity: 1; font-family: 나눔스퀘어, 나눔스퀘어_EmbeddedFont, 나눔스퀘어_MSFontService, sans-serif; font-kerning: none; font-optical-sizing: auto; font-size: 16.8px; font-stretch: 100%; font-variant-ligatures: no-common-ligatures no-discretionary-ligatures no-historical-ligatures no-contextual; font-variant-numeric: normal; font-variant-east-asian: normal; grid: auto-flow auto / none; grid-area: auto / auto / auto / auto; height: auto; hyphens: manual; image-orientation: from-image; image-rendering: auto; inline-size: auto; isolation: auto; lighting-color: #ffffff; line-height: 30px; list-style: outside none disc; margin-block: 0px; margin: 0px; margin-inline: 0px; marker: none; mask-type: luminance; max-block-size: none; max-height: none; max-inline-size: none; max-width: none; min-block-size: 0px; min-height: 0px; min-inline-size: 0px; min-width: 0px; mix-blend-mode: normal; object-fit: fill; object-position: 50% 50%; offset: none 0px auto 0deg; opacity: 1; order: 0; outline: #5f5f5f none 0px; outline-offset: 0px; overflow-anchor: auto; overflow-wrap: break-word; overflow: visible; overscroll-behavior-block: auto; overscroll-behavior-inline: auto; padding-block: 0px 1.78px; padding: 0px 0px 1.78px; padding-inline: 0px; paint-order: normal; perspective: none; perspective-origin: 0px 0px; pointer-events: all; position: static; r: 0px; resize: none; ruby-position: over; rx: auto; ry: auto; scroll-behavior: auto; scroll-margin-block: 0px; scroll-margin-inline: 0px; scroll-padding-block: auto; scroll-padding-inline: auto; shape-image-threshold: 0; shape-margin: 0px; shape-outside: none; shape-rendering: auto; speak: normal; stop-color: #000000; stop-opacity: 1; stroke: none; stroke-dasharray: none; stroke-dashoffset: 0px; stroke-linecap: butt; stroke-linejoin: miter; stroke-miterlimit: 4; stroke-opacity: 1; stroke-width: 1px; tab-size: 8; table-layout: auto; text-align-last: auto; text-anchor: start; text-decoration-style: solid; text-decoration-color: #5f5f5f; text-decoration-skip-ink: none; text-overflow: clip; text-rendering: auto; text-shadow: none; text-size-adjust: auto; text-underline-position: auto; touch-action: pan-x pan-y; transform: none; transform-origin: 0px 0px; transform-style: flat; transition: all 0s ease 0s; unicode-bidi: normal; user-select: text; vector-effect: none; vertical-align: 1.78px; visibility: visible; width: auto; will-change: auto; word-break: normal; writing-mode: horizontal-tb; x: 0px; y: 0px; z-index: auto; zoom: 1; app-region: none; border-spacing: 0px; -webkit-border-image: none; -webkit-box-align: stretch; -webkit-box-decoration-break: slice; -webkit-box-direction: normal; -webkit-box-flex: 0; -webkit-box-ordinal-group: 1; -webkit-box-orient: horizontal; -webkit-box-pack: start; -webkit-font-smoothing: auto; -webkit-highlight: none; -webkit-hyphenate-character: auto; -webkit-line-break: after-white-space; -webkit-locale: \'KO-KR\'; -webkit-mask-box-image-outset: 0; -webkit-mask-box-image-repeat: stretch; -webkit-mask-box-image-slice: 0 fill; -webkit-mask-box-image-source: none; -webkit-mask-box-image-width: auto; -webkit-mask: none 0% 0% / auto repeat border-box border-box; -webkit-mask-composite: source-over; -webkit-print-color-adjust: economy; -webkit-rtl-ordering: logical; -webkit-tap-highlight-color: rgba(0, 0, 0, 0); -webkit-text-combine: none; text-emphasis: none #5f5f5f; text-emphasis-position: over right; -webkit-text-fill-color: #5f5f5f; -webkit-text-orientation: vertical-right; -webkit-text-security: none; -webkit-text-stroke-color: #5f5f5f; -webkit-user-drag: none; -webkit-user-modify: read-write; -webkit-writing-mode: horizontal-tb;" xml:lang="KO-KR" data-scheme-color="@5F5F5F,," data-usefontface="true" data-contrast="none"><span class="NormalTextRun SCXP245900678 BCX9" style="vertical-align: -1.78px; line-height: 0px; position: relative;">반응형 웹 디자인 구현</span></span></li>\n</ul>',
          logos: [228],
          date_published: '2022-05-09T22:43:04.000Z',
          main_cat: 3,
          categories: [3],
          industries: [4],
          sectors: [8],
          logoFiles: [
            {
              id: 228,
              name: 'Samsung.png',
              url: '/media/20220527/1653632493.png',
              thumb_url: '/media/20220527/thumb-1653632493.png',
              mimetype: 'image/png',
              size: 11320,
              date_uploaded: '2022-05-26T21:21:33.000Z',
              uploader_id: 1,
            },
          ],
        },
        {
          id: 37,
          image_thumb_url: '/media/20220510/thumb-1652168499.jpg',
          image_url: '/media/20220510/1652168499.jpg',
          name: 'LG',
          subname: ' ',
          description:
            '<ul>\n<li><strong>LG전자 &ndash; 핸드폰 매뉴얼 온라인 콘텐츠 변환</strong></li>\n<li><strong>InDesign -&gt; </strong>Web Manual 변환 도구</li>\n<li>HTML5, CSS3, JS 표준 적용</li>\n<li>반응형 웹 디자인 구현</li>\n</ul>',
          logos: [233],
          date_published: '2022-05-09T22:41:42.000Z',
          main_cat: 3,
          categories: [3],
          industries: [4],
          sectors: [8],
          logoFiles: [
            {
              id: 233,
              name: 'MicrosoftTeams-image (1).png',
              url: '/media/20220527/1653633265.png',
              thumb_url: '/media/20220527/thumb-1653633265.png',
              mimetype: 'image/png',
              size: 15909,
              date_uploaded: '2022-05-26T21:34:25.000Z',
              uploader_id: 1,
            },
          ],
        },
        {
          id: 36,
          image_thumb_url: '/media/20220510/thumb-1652168343.jpg',
          image_url: '/media/20220510/1652168343.jpg',
          name: 'Hyundai',
          subname: '.',
          description:
            '<ul>\n<li>현대기아자동차 &ndash; 인포테인먼트 시스템 매뉴얼 온라인 콘텐츠 변환</li>\n<li>InDesign -&gt; Web Manual 변환 도구</li>\n<li>HTML5, CSS3, JS 표준 적용</li>\n<li>반응형 웹 디자인 구현</li>\n</ul>',
          logos: [230, 1318],
          date_published: '2022-05-09T22:39:06.000Z',
          main_cat: 3,
          categories: [3],
          industries: [5],
          sectors: [8],
          logoFiles: [
            {
              id: 230,
              name: 'Hyundai.png',
              url: '/media/20220527/1653632590.png',
              thumb_url: '/media/20220527/thumb-1653632590.png',
              mimetype: 'image/png',
              size: 9487,
              date_uploaded: '2022-05-26T21:23:10.000Z',
              uploader_id: 1,
            },
            {
              id: 1318,
              name: '흰색.png',
              url: '/media/20230919/1695080422-흰색.png',
              thumb_url: '/media/20230919/thumb-1695080422.jpg',
              mimetype: 'image/png',
              size: 3136,
              date_uploaded: '2023-09-18T23:40:23.000Z',
              uploader_id: 2,
            },
          ],
        },
        {
          id: 35,
          image_thumb_url: '/media/20220510/thumb-1652168221.jpg',
          image_url: '/media/20220510/1652168221.jpg',
          name: 'Samsung',
          subname: ' ',
          description:
            '<ul>\n<li>삼성전자 &ndash; 프린터 매뉴얼 온라인 콘텐츠 변환</li>\n<li>FrameMaker (DITA) -&gt; Web Manual 변환 도구​</li>\n<li>HTML5, CSS3, JS 표준 적용</li>\n<li>반응형 웹 디자인 구현</li>\n</ul>',
          logos: [228],
          date_published: '2022-05-09T22:37:05.000Z',
          main_cat: 3,
          categories: [3],
          industries: [1],
          sectors: [8],
          logoFiles: [
            {
              id: 228,
              name: 'Samsung.png',
              url: '/media/20220527/1653632493.png',
              thumb_url: '/media/20220527/thumb-1653632493.png',
              mimetype: 'image/png',
              size: 11320,
              date_uploaded: '2022-05-26T21:21:33.000Z',
              uploader_id: 1,
            },
          ],
        },
        {
          id: 34,
          image_thumb_url: '/media/20220510/thumb-1652168095.jpg',
          image_url: '/media/20220510/1652168095.jpg',
          name: 'Samsung',
          subname: ' ',
          description:
            '<ul>\n<li>삼성테크윈 &ndash; 디지털 카메라 매뉴얼 온라인 콘텐츠 변환</li>\n<li>InDesign -&gt; Web Manual 변환 도구</li>\n<li>HTML5, CSS3, JS 표준 적용</li>\n<li>반응형 웹 디자인 구현</li>\n</ul>',
          logos: [228],
          date_published: '2022-05-09T22:34:58.000Z',
          main_cat: 3,
          categories: [3],
          industries: [1],
          sectors: [8],
          logoFiles: [
            {
              id: 228,
              name: 'Samsung.png',
              url: '/media/20220527/1653632493.png',
              thumb_url: '/media/20220527/thumb-1653632493.png',
              mimetype: 'image/png',
              size: 11320,
              date_uploaded: '2022-05-26T21:21:33.000Z',
              uploader_id: 1,
            },
          ],
        },
        {
          id: 33,
          image_thumb_url: '/media/20220510/thumb-1652168001.jpg',
          image_url: '/media/20220510/1652168001.jpg',
          name: 'Samsung',
          subname: ' ',
          description:
            '<ul>\n<li>반도체 장비 콘솔 탑재용 운영 매뉴얼 앱 (안드로이드)</li>\n<li>콘텐츠 변환 및 배포 구조 개발</li>\n<li>자동 업데이트 및 알림 기능</li>\n</ul>',
          logos: [228],
          date_published: '2022-05-09T22:33:24.000Z',
          main_cat: 3,
          categories: [3],
          industries: [7],
          sectors: [7],
          logoFiles: [
            {
              id: 228,
              name: 'Samsung.png',
              url: '/media/20220527/1653632493.png',
              thumb_url: '/media/20220527/thumb-1653632493.png',
              mimetype: 'image/png',
              size: 11320,
              date_uploaded: '2022-05-26T21:21:33.000Z',
              uploader_id: 1,
            },
          ],
        },
        {
          id: 32,
          image_thumb_url: '/media/20220510/thumb-1652167937.jpg',
          image_url: '/media/20220510/1652167937.jpg',
          name: 'LG',
          subname: ' ',
          description:
            '<ul>\n<li>스마트 TV 사용자 매뉴얼 앱 개발 (WebOS)</li>\n<li>XML 사용자 매뉴얼 문서를 어플리케이션과&nbsp; 동작하도록 콘텐츠 저작 및 배포 구조 개발</li>\n</ul>',
          logos: [233],
          date_published: '2022-05-09T22:32:20.000Z',
          main_cat: 3,
          categories: [3],
          industries: [4],
          sectors: [7],
          logoFiles: [
            {
              id: 233,
              name: 'MicrosoftTeams-image (1).png',
              url: '/media/20220527/1653633265.png',
              thumb_url: '/media/20220527/thumb-1653633265.png',
              mimetype: 'image/png',
              size: 15909,
              date_uploaded: '2022-05-26T21:34:25.000Z',
              uploader_id: 1,
            },
          ],
        },
        {
          id: 31,
          image_thumb_url: '/media/20220510/thumb-1652167887.jpg',
          image_url: '/media/20220510/1652167887.jpg',
          name: 'LG',
          subname: ' ',
          description:
            '<ul>\n<li>LG 휴대폰 임베디드 사용자 매뉴얼 어플리케이션 (안드로이드)</li>\n<li>XML 사용자 매뉴얼 문서를 어플리케이션과&nbsp; 동작하도록 콘텐츠 저작 및 배포 구조 개발</li>\n</ul>',
          logos: [233],
          date_published: '2022-05-09T22:31:31.000Z',
          main_cat: 3,
          categories: [3],
          industries: [4],
          sectors: [7],
          logoFiles: [
            {
              id: 233,
              name: 'MicrosoftTeams-image (1).png',
              url: '/media/20220527/1653633265.png',
              thumb_url: '/media/20220527/thumb-1653633265.png',
              mimetype: 'image/png',
              size: 15909,
              date_uploaded: '2022-05-26T21:34:25.000Z',
              uploader_id: 1,
            },
          ],
        },
        {
          id: 30,
          image_thumb_url: '/media/20220510/thumb-1652167845.jpg',
          image_url: '/media/20220510/1652167845.jpg',
          name: 'LG',
          subname: ' ',
          description:
            '<p>&nbsp;</p>\n<ul>\n<li>LG 노트북 임베디드 사용자 매뉴얼 어플리케이션 (윈도우 7,8,10용)</li>\n<li>XML 사용자 매뉴얼 문서를 어플리케이션과&nbsp; 동작하도록 콘텐츠 저작 및 배포 구조 개발</li>\n</ul>',
          logos: [233],
          date_published: '2022-05-09T22:30:48.000Z',
          main_cat: 3,
          categories: [3],
          industries: [4],
          sectors: [7],
          logoFiles: [
            {
              id: 233,
              name: 'MicrosoftTeams-image (1).png',
              url: '/media/20220527/1653633265.png',
              thumb_url: '/media/20220527/thumb-1653633265.png',
              mimetype: 'image/png',
              size: 15909,
              date_uploaded: '2022-05-26T21:34:25.000Z',
              uploader_id: 1,
            },
          ],
        },
        {
          id: 29,
          image_thumb_url: '/media/20220510/thumb-1652167774.jpg',
          image_url: '/media/20220510/1652167774.jpg',
          name: ' 현대엘리베이터',
          subname: ' ',
          description:
            '<ul>\n<li>현대엘리베이터 &ndash; XML 기술문서 저작/관리 시스템</li>\n<li>DITA 기술 매뉴얼 관리 포털</li>\n<li>대시보드, 레포지토리, 워크플로우, 버전관리, 검색, SSO 연동</li>\n<li>XML 분산 저작, 협업 관리, 맵 관리, 프로파일링, PDF 자동 스타일</li>\n</ul>',
          logos: [176],
          date_published: '2022-05-09T22:29:37.000Z',
          main_cat: 3,
          categories: [3],
          industries: [2],
          sectors: [6],
          logoFiles: [
            {
              id: 176,
              name: 'Hyundai_elevator_logo.png',
              url: '/media/20220510/1652167764.png',
              thumb_url: '/media/20220510/thumb-1652167764.png',
              mimetype: 'image/png',
              size: 23408,
              date_uploaded: '2022-05-09T22:29:24.000Z',
              uploader_id: 1,
            },
          ],
        },
        {
          id: 28,
          image_thumb_url: '/media/20220510/thumb-1652167679.jpg',
          image_url: '/media/20220510/1652167679.jpg',
          name: '한국 선급',
          subname: ' ',
          description:
            '<ul>\n<li><strong>한국선급 &ndash; PQ 문서 관리 시스템</strong></li>\n<li>DB 기반 문서 생성(docx) 시스템</li>\n<li>대시보드, 레포지토리, 워크플로우, 버전관리, 검색, 번역 지원 기능 구현</li>\n</ul>',
          logos: [229],
          date_published: '2022-05-09T22:28:01.000Z',
          main_cat: 3,
          categories: [3],
          industries: [5],
          sectors: [6],
          logoFiles: [
            {
              id: 229,
              name: 'KR - V2.png',
              url: '/media/20220527/1653632510.png',
              thumb_url: '/media/20220527/thumb-1653632510.png',
              mimetype: 'image/png',
              size: 17319,
              date_uploaded: '2022-05-26T21:21:50.000Z',
              uploader_id: 1,
            },
          ],
        },
        {
          id: 27,
          image_thumb_url: '/media/20220510/thumb-1652167596.jpg',
          image_url: '/media/20220510/1652167596.jpg',
          name: 'Samsung',
          subname: ' ',
          description:
            '<p>&nbsp;</p>\n<ul>\n<li>네트워크 기술 문서 배포 시스템</li>\n<li>Word, PDF, Web Help 자동 변환</li>\n<li>사용자 가입, 라이선스 관리, 버전, 제품 유형, 커뮤니티 관리, 통계 관리 기능</li>\n<li>기간별 콘텐츠 자동 분류, 문서 버전 관리, 통합 검색 구현</li>\n</ul>',
          logos: [228],
          date_published: '2022-05-09T22:26:38.000Z',
          main_cat: 3,
          categories: [3],
          industries: [4],
          sectors: [6],
          logoFiles: [
            {
              id: 228,
              name: 'Samsung.png',
              url: '/media/20220527/1653632493.png',
              thumb_url: '/media/20220527/thumb-1653632493.png',
              mimetype: 'image/png',
              size: 11320,
              date_uploaded: '2022-05-26T21:21:33.000Z',
              uploader_id: 1,
            },
          ],
        },
        {
          id: 26,
          image_thumb_url: '/media/20220510/thumb-1652167146.jpg',
          image_url: '/media/20220510/1652167146.jpg',
          name: ' 켄델라코리아',
          subname: ' ',
          description:
            '<ul>\n<li>글로벌 미용의료기기 제품 홍보 및 교육을 목적으로 제품들에 대한 소개, 특징, 장점을 설명하는 매뉴얼, 브로슈어, 교육자료 등 번역&nbsp;</li>\n</ul>',
          logos: [227],
          date_published: '2022-05-09T22:24:08.000Z',
          main_cat: 2,
          categories: [2],
          industries: [3],
          sectors: [3],
          logoFiles: [
            {
              id: 227,
              name: 'Candela.png',
              url: '/media/20220527/1653632477.png',
              thumb_url: '/media/20220527/thumb-1653632477.png',
              mimetype: 'image/png',
              size: 17192,
              date_uploaded: '2022-05-26T21:21:17.000Z',
              uploader_id: 1,
            },
          ],
        },
        {
          id: 25,
          image_thumb_url: '/media/20220510/thumb-1652166938.jpg',
          image_url: '/media/20220510/1652166938.jpg',
          name: '비상 교육',
          subname: ' ',
          description:
            '<ul>\n<li>유아 및 초중고 학생들 교육을 목적으로 자기주도 학습을 목표로 작성된 교재, 온라인 콘텐츠와 기업 홍보 자료에 대한 번역</li>\n</ul>',
          logos: [226],
          date_published: '2022-05-09T22:15:50.000Z',
          main_cat: 2,
          categories: [2],
          industries: [8],
          sectors: [3],
          logoFiles: [
            {
              id: 226,
              name: 'Visang.png',
              url: '/media/20220527/1653632460.png',
              thumb_url: '/media/20220527/thumb-1653632460.png',
              mimetype: 'image/png',
              size: 12343,
              date_uploaded: '2022-05-26T21:21:00.000Z',
              uploader_id: 1,
            },
          ],
        },
        {
          id: 24,
          image_thumb_url: '/media/20220510/thumb-1652166740.jpg',
          image_url: '/media/20220510/1652166740.jpg',
          name: '펑션베이',
          subname: ' ',
          description:
            '<ul>\n<li>다물체 동역학 해석과 비선형 유한 요소 해석을 하나의 적분기에서 통합하는 MFBD(Multi Flexible Body Dynamics)를 핵심으로 하며, 이에 Control(제어기 설계)과 피로해석을 추가하여 한층 업그레이드 된 CAE 환경 구축을 위해 개발된 Software에 대한 번역</li>\n</ul>',
          logos: [166],
          date_published: '2022-05-09T22:12:24.000Z',
          main_cat: 2,
          categories: [2],
          industries: [4],
          sectors: [3],
          logoFiles: [
            {
              id: 166,
              name: 'FunctionBay-logo.png',
              url: '/media/20220510/1652166714.png',
              thumb_url: '/media/20220510/thumb-1652166714.png',
              mimetype: 'image/png',
              size: 17896,
              date_uploaded: '2022-05-09T22:11:54.000Z',
              uploader_id: 1,
            },
          ],
        },
        {
          id: 23,
          image_thumb_url: '/media/20220510/thumb-1652166676.jpg',
          image_url: '/media/20220510/1652166676.jpg',
          name: ' Mujin',
          subname: ' ',
          description:
            '<ul>\n<li>무진전자 &lsquo;NSM&rsquo; 장비의 유지보수 담당자가&nbsp; 본 장비를 정기적으로 점검하고 적절한 유지보수 작업을 수행할 수 있도록 돕기 위한 유지보수 매뉴얼</li>\n<li>웨이퍼 세정 장비 표준 매뉴얼 기획 및 제작</li>\n</ul>',
          logos: [225],
          date_published: '2022-05-09T22:11:22.000Z',
          main_cat: 1,
          categories: [1],
          industries: [7],
          sectors: [1],
          logoFiles: [
            {
              id: 225,
              name: 'Mujin.png',
              url: '/media/20220527/1653632397.png',
              thumb_url: '/media/20220527/thumb-1653632397.png',
              mimetype: 'image/png',
              size: 6447,
              date_uploaded: '2022-05-26T21:19:57.000Z',
              uploader_id: 1,
            },
          ],
        },
        {
          id: 22,
          image_thumb_url: '/media/20220510/thumb-1652166626.jpg',
          image_url: '/media/20220510/1652166626.jpg',
          name: ' (주)유진테크',
          subname: ' ',
          description:
            '<ul>\n<li>(주)유진테크의 BlueJay M3000TM 장비의 매뉴얼</li>\n<li>반도체 장비 국제 표준 매뉴얼에 따른 기획 및 제작</li>\n</ul>',
          logos: [162],
          date_published: '2022-05-09T22:10:31.000Z',
          main_cat: 1,
          categories: [1],
          industries: [7],
          sectors: [1],
          logoFiles: [
            {
              id: 162,
              name: 'EUGENE.png',
              url: '/media/20220510/1652166615.png',
              thumb_url: '/media/20220510/thumb-1652166615.png',
              mimetype: 'image/png',
              size: 15945,
              date_uploaded: '2022-05-09T22:10:15.000Z',
              uploader_id: 1,
            },
          ],
        },
        {
          id: 21,
          image_thumb_url: '/media/20220510/thumb-1652166572.jpg',
          image_url: '/media/20220510/1652166572.jpg',
          name: ' 원익테라세미콘',
          subname: ' ',
          description:
            '<ul>\n<li>테라세미콘 &lsquo;300SP&rsquo; 장비의 유지보수 담당자가 본 장비를 정기적으로 점검하고 적절한 유지보수 작업을 수행할 수 있도록 돕기 위한 유지보수 매뉴얼</li>\n<li>웨이퍼 애칭 장비 표준 매뉴얼 5종 기획 및 제작</li>\n</ul>',
          logos: [160],
          date_published: '2022-05-09T22:09:39.000Z',
          main_cat: 1,
          categories: [1],
          industries: [7],
          sectors: [1],
          logoFiles: [
            {
              id: 160,
              name: '테라세미콘.png',
              url: '/media/20220510/1652166566.png',
              thumb_url: '/media/20220510/thumb-1652166566.png',
              mimetype: 'image/png',
              size: 26283,
              date_uploaded: '2022-05-09T22:09:26.000Z',
              uploader_id: 1,
            },
          ],
        },
        {
          id: 20,
          image_thumb_url: '/media/20220510/thumb-1652166494.jpg',
          image_url: '/media/20220510/1652166494.jpg',
          name: ' 국제엘렉트릭코리아(주)',
          subname: ' ',
          description:
            '<ul>\n<li>KEK(국제엘렉트릭) &lsquo;NONET&rsquo; 장비의 유지보수 담당자가 본 장비를 정기적으로 점검하고 적절한 유지보수 작업을 수행할 수 있도록 돕기 위한 유지보수 매뉴얼</li>\n<li>웨이퍼 애칭 장비 표준 매뉴얼 5종 기획 및 제작</li>\n</ul>',
          logos: [158],
          date_published: '2022-05-09T22:08:22.000Z',
          main_cat: 1,
          categories: [1],
          industries: [7],
          sectors: [1],
          logoFiles: [
            {
              id: 158,
              name: '국제엘렉트릭코리아.png',
              url: '/media/20220510/1652166487.png',
              thumb_url: '/media/20220510/thumb-1652166487.png',
              mimetype: 'image/png',
              size: 38296,
              date_uploaded: '2022-05-09T22:08:07.000Z',
              uploader_id: 1,
            },
          ],
        },
        {
          id: 19,
          image_thumb_url: '/media/20220510/thumb-1652166443.jpg',
          image_url: '/media/20220510/1652166443.jpg',
          name: ' PSK',
          subname: ' ',
          description:
            '<ul>\n<li>PSK &lsquo;PROFILER&rsquo; 장비의 유지보수 담당자가 본 장비를 정기적으로 점검하고 적절한 유지보수 작업을 수행할 수 있도록 돕기 위한 유지보수 매뉴얼</li>\n<li>웨이<strong>퍼</strong> 세정 장비 표준 매뉴얼 5종 기획 및 제작</li>\n</ul>',
          logos: [235],
          date_published: '2022-05-09T22:07:26.000Z',
          main_cat: 1,
          categories: [1],
          industries: [7],
          sectors: [1],
          logoFiles: [
            {
              id: 235,
              name: 'MicrosoftTeams-image.png',
              url: '/media/20220527/1653633416.png',
              thumb_url: '/media/20220527/thumb-1653633416.png',
              mimetype: 'image/png',
              size: 11161,
              date_uploaded: '2022-05-26T21:36:56.000Z',
              uploader_id: 1,
            },
          ],
        },
        {
          id: 18,
          image_thumb_url: '/media/20220510/thumb-1652166389.jpg',
          image_url: '/media/20220510/1652166389.jpg',
          name: ' SEMES',
          subname: ' ',
          description:
            '<ul>\n<li>세메스㈜ &lsquo;IRIS V500&rsquo; 장비의 유지보수 담당자가 본 장비를 정기적으로 점검하고 적절한 유지보수 작업을&nbsp; &nbsp;수행할 수 있도록 돕기 위한 표준 매뉴얼</li>\n<li>웨이퍼 세정 장비 국제 표준 매뉴얼에 따른 기획 및 제작</li>\n</ul>',
          logos: [223],
          date_published: '2022-05-09T22:06:33.000Z',
          main_cat: 1,
          categories: [1],
          industries: [7],
          sectors: [1],
          logoFiles: [
            {
              id: 223,
              name: 'Semes.png',
              url: '/media/20220527/1653632299.png',
              thumb_url: '/media/20220527/thumb-1653632299.png',
              mimetype: 'image/png',
              size: 14269,
              date_uploaded: '2022-05-26T21:18:19.000Z',
              uploader_id: 1,
            },
          ],
        },
        {
          id: 17,
          image_thumb_url: '/media/20220510/thumb-1652166192.jpg',
          image_url: '/media/20220510/1652166192.jpg',
          name: '듀오백',
          subname: ' ',
          description:
            '<ul>\n<li>단순한 문서 형식의 매뉴얼이 아닌 홍보 및 제품 소개를 위한 종합 카탈로그 컨셉의 매뉴얼 제작</li>\n<li>단순히 사용자에게 장비에 대한 사용법을 나열하는 방식의 매뉴얼이 아닌 이미지의 연결성을 통해 하나의 스토리로 사용자에게 장비를 설명하는 매뉴얼 제작</li>\n</ul>',
          logos: [222],
          date_published: '2022-05-09T22:03:15.000Z',
          main_cat: 2,
          categories: [2],
          industries: [6],
          sectors: [2, 3],
          logoFiles: [
            {
              id: 222,
              name: 'Duoback.png',
              url: '/media/20220527/1653632283.png',
              thumb_url: '/media/20220527/thumb-1653632283.png',
              mimetype: 'image/png',
              size: 10448,
              date_uploaded: '2022-05-26T21:18:03.000Z',
              uploader_id: 1,
            },
          ],
        },
        {
          id: 16,
          image_thumb_url: '/media/20220510/thumb-1652166104.jpg',
          image_url: '/media/20220510/1652166104.jpg',
          name: 'PLY',
          subname: ' ',
          description:
            '<ul>\n<li>사용자가 제품 구매 후 기본적인 사용법을 익히고 적절한 유지보수 방법 및 보증 내용에 대해 이해를 돕는 표준 매뉴얼 제작</li>\n<li>제품의 특징을 부각시키고 효과적인 대외 홍보를 위한 제품 포스터 제작</li>\n<li>신제품의 특장점을 홍보하기 위한 브로슈어 제작</li>\n</ul>',
          logos: [221],
          date_published: '2022-05-09T22:01:48.000Z',
          main_cat: 1,
          categories: [1],
          industries: [6],
          sectors: [1],
          logoFiles: [
            {
              id: 221,
              name: 'PLY - Eco cell.png',
              url: '/media/20220527/1653632266.png',
              thumb_url: '/media/20220527/thumb-1653632266.png',
              mimetype: 'image/png',
              size: 7242,
              date_uploaded: '2022-05-26T21:17:46.000Z',
              uploader_id: 1,
            },
          ],
        },
        {
          id: 15,
          image_thumb_url: '/media/20220510/thumb-1652166001.jpg',
          image_url: '/media/20220510/1652166001.jpg',
          name: '에스원',
          subname: ' ',
          description:
            '<p>&nbsp;</p>\n<ul>\n<li>기존의 GUI를 개선하고 디자인 컨셉과 가이드에 맞게 새로운 프로그램 GUI 제작</li>\n</ul>',
          logos: [220],
          date_published: '2022-05-09T22:00:03.000Z',
          main_cat: 1,
          categories: [1],
          industries: [4],
          sectors: [5, 3],
          logoFiles: [
            {
              id: 220,
              name: '에스원 -  V2.png',
              url: '/media/20220527/1653632247.png',
              thumb_url: '/media/20220527/thumb-1653632247.png',
              mimetype: 'image/png',
              size: 7857,
              date_uploaded: '2022-05-26T21:17:27.000Z',
              uploader_id: 1,
            },
          ],
        },
        {
          id: 14,
          image_thumb_url: '/media/20220510/thumb-1652165887.jpg',
          image_url: '/media/20220510/1652165887.jpg',
          name: 'Samsung',
          subname: ' ',
          description:
            '<p>&nbsp;</p>\n<ul>\n<li>네트워크 매뉴얼 전용 클라이언트 (안드로이드, iOS, 윈도우)</li>\n<li>온/오프라인 로그인 기능</li>\n<li>문서 검색, 열람, 다운로드, 북마크, Q&amp;A 기능</li>\n<li>다운로드 문서 자동 업데이트 기능</li>\n</ul>',
          logos: [191],
          date_published: '2022-05-09T21:58:13.000Z',
          main_cat: 1,
          categories: [1],
          industries: [4],
          sectors: [5, 3],
          logoFiles: [
            {
              id: 191,
              name: 'Samsung_Logo.png',
              url: '/media/20220510/1652168568.png',
              thumb_url: '/media/20220510/thumb-1652168568.png',
              mimetype: 'image/png',
              size: 13250,
              date_uploaded: '2022-05-09T22:42:48.000Z',
              uploader_id: 1,
            },
          ],
        },
        {
          id: 13,
          image_thumb_url: '/media/20220510/thumb-1652165731.jpg',
          image_url: '/media/20220510/1652165731.jpg',
          name: 'icroface',
          subname: ' ',
          description:
            '<ul>\n<li>사용자가 제품 구매 후 기본적인 사용법을 익히고 적절한 유지보수 방법 및 보증 내용에 대해 이해를 돕는 표준 매뉴얼 제작</li>\n</ul>',
          logos: [232],
          date_published: '2022-05-09T21:55:34.000Z',
          main_cat: 1,
          categories: [1],
          industries: [4],
          sectors: [1],
          logoFiles: [
            {
              id: 232,
              name: 'MicrosoftTeams-image (2).png',
              url: '/media/20220527/1653633240.png',
              thumb_url: '/media/20220527/thumb-1653633240.png',
              mimetype: 'image/png',
              size: 29596,
              date_uploaded: '2022-05-26T21:34:00.000Z',
              uploader_id: 1,
            },
          ],
        },
        {
          id: 12,
          image_thumb_url: '/media/20220510/thumb-1652165688.jpg',
          image_url: '/media/20220510/1652165688.jpg',
          name: 'LG',
          subname: ' ',
          description:
            '<ul>\n<li>사용자가 제품 구매 후 기본적인 사용법을 익히고 적절한 유지보수 방법 및 보증 내용에 대해 이해를 돕는 표준 매뉴얼 제작</li>\n</ul>',
          logos: [233],
          date_published: '2022-05-09T21:54:52.000Z',
          main_cat: 2,
          categories: [2],
          industries: [4],
          sectors: [3, 1],
          logoFiles: [
            {
              id: 233,
              name: 'MicrosoftTeams-image (1).png',
              url: '/media/20220527/1653633265.png',
              thumb_url: '/media/20220527/thumb-1653633265.png',
              mimetype: 'image/png',
              size: 15909,
              date_uploaded: '2022-05-26T21:34:25.000Z',
              uploader_id: 1,
            },
          ],
        },
        {
          id: 11,
          image_thumb_url: '/media/20220510/thumb-1652165636.jpg',
          image_url: '/media/20220510/1652165636.jpg',
          name: 'ketoplus',
          subname: ' ',
          description:
            '<ul>\n<li>사용자가 제품 구매 후 기본적인 사용법을 익히고 적절한 유지보수 방법 및 보증 내용에 대해 이해를 돕는 표준 매뉴얼 제작</li>\n<li>단순한 문서 형식의 매뉴얼이 아닌 홍보 및 제품 소개를 위한 브로슈어 컨셉의 매뉴얼 제작</li>\n</ul>',
          logos: [216],
          date_published: '2022-05-09T21:54:00.000Z',
          main_cat: 1,
          categories: [1],
          industries: [3],
          sectors: [1],
          logoFiles: [
            {
              id: 216,
              name: 'KetoPlus.png',
              url: '/media/20220527/1653632084.png',
              thumb_url: '/media/20220527/thumb-1653632084.png',
              mimetype: 'image/png',
              size: 18224,
              date_uploaded: '2022-05-26T21:14:44.000Z',
              uploader_id: 1,
            },
          ],
        },
        {
          id: 10,
          image_thumb_url: '/media/20220510/thumb-1652165238.jpg',
          image_url: '/media/20220510/1652165238.jpg',
          name: 'SDMED',
          subname: ' ',
          description:
            '<ul>\n<li>사용자가 제품 구매 후 기본적인 사용법을 익히고 적절한 유지보수 방법 및 보증 내용에 대해 이해를 돕는 표준 매뉴얼 제작</li>\n</ul>',
          logos: [215],
          date_published: '2022-05-09T21:47:23.000Z',
          main_cat: 1,
          categories: [1],
          industries: [3],
          sectors: [1],
          logoFiles: [
            {
              id: 215,
              name: 'SB Med.png',
              url: '/media/20220527/1653632068.png',
              thumb_url: '/media/20220527/thumb-1653632068.png',
              mimetype: 'image/png',
              size: 46901,
              date_uploaded: '2022-05-26T21:14:28.000Z',
              uploader_id: 1,
            },
          ],
        },
        {
          id: 9,
          image_thumb_url: '/media/20220510/thumb-1652165174.jpg',
          image_url: '/media/20220510/1652165174.jpg',
          name: 'i-NEM',
          subname: '',
          description:
            '<ul>\n<li>단순히 사용자에게 장비에 대한 사용법을 나열하는 방식의 매뉴얼이 아닌 이미지의 연결성을 통해 하나의 스토리로 사용자에게 장비를 설명하는 매뉴얼 제작</li>\n</ul>',
          logos: [214],
          date_published: '2022-05-09T21:46:29.000Z',
          main_cat: 1,
          categories: [1],
          industries: [3],
          sectors: [2],
          logoFiles: [
            {
              id: 214,
              name: 'I Nem.png',
              url: '/media/20220527/1653632051.png',
              thumb_url: '/media/20220527/thumb-1653632051.png',
              mimetype: 'image/png',
              size: 29973,
              date_uploaded: '2022-05-26T21:14:11.000Z',
              uploader_id: 1,
            },
          ],
        },
        {
          id: 8,
          image_thumb_url: '/media/20220510/thumb-1652165053.jpg',
          image_url: '/media/20220510/1652165053.jpg',
          name: 'HFR',
          subname: ' ',
          description:
            '<p>&nbsp;</p>\n<ul>\n<li>제품 홍보를 목적으로 모든 제품군에 대한 특징과 장점을 설명하는 종합 제품 카탈로그, 브로슈어 제작</li>\n<li>제품과 기업에 대한 이미지를 시각적으로 임팩트 있게 표현할 수 있는 포스터 제작</li>\n</ul>',
          logos: [213],
          date_published: '2022-05-09T21:44:52.000Z',
          main_cat: 1,
          categories: [1],
          industries: [2],
          sectors: [2, 3],
          logoFiles: [
            {
              id: 213,
              name: 'HGR, Inc.png',
              url: '/media/20220527/1653632029.png',
              thumb_url: '/media/20220527/thumb-1653632029.png',
              mimetype: 'image/png',
              size: 17447,
              date_uploaded: '2022-05-26T21:13:49.000Z',
              uploader_id: 1,
            },
          ],
        },
        {
          id: 7,
          image_thumb_url: '/media/20220510/thumb-1652164814.jpg',
          image_url: '/media/20220510/1652164814.jpg',
          name: 'D-Zen',
          subname: ' ',
          description:
            '<ul>\n<li>제품 홍보를 목적으로 모든 제품군에 대한 특징과 장점을 설명하는 종합 제품 카탈로그 제작</li>\n</ul>',
          logos: [212],
          date_published: '2022-05-09T21:43:15.000Z',
          main_cat: 1,
          categories: [1],
          industries: [2],
          sectors: [2, 3],
          logoFiles: [
            {
              id: 212,
              name: 'D Gen.png',
              url: '/media/20220527/1653631999.png',
              thumb_url: '/media/20220527/thumb-1653631999.png',
              mimetype: 'image/png',
              size: 15035,
              date_uploaded: '2022-05-26T21:13:19.000Z',
              uploader_id: 1,
            },
          ],
        },
        {
          id: 6,
          image_thumb_url: '/media/20220510/thumb-1652163647.jpg',
          image_url: '/media/20220510/1652163647.jpg',
          name: 'ARGUS',
          subname: '-',
          description:
            '<ul>\n<li>시스템의 작동 원리 및 특징을 인포그래픽으로 구성하여 복잡한 개념을 쉽게 전달하도록 제작된 브로슈어</li>\n</ul>',
          logos: [240],
          date_published: '2022-05-09T21:20:55.000Z',
          main_cat: 1,
          categories: [1],
          industries: [2],
          sectors: [2],
          logoFiles: [
            {
              id: 240,
              name: 'argus.png',
              url: '/media/20220613/1655092630.png',
              thumb_url: '/media/20220613/1655092630.png',
              mimetype: 'image/png',
              size: 15114,
              date_uploaded: '2022-06-12T18:57:10.000Z',
              uploader_id: 1,
            },
          ],
        },
        {
          id: 5,
          image_thumb_url: '/media/20220510/thumb-1652163461.jpg',
          image_url: '/media/20220510/1652163461.jpg',
          name: '에코 파워텍',
          subname: '',
          description:
            '<p>&nbsp;</p>\n<ul>\n<li>사용자가 소프트웨어 사용에 필요한 절차, 환경 등의 제반 사항이 모두 포함되도록 작성된 소프트웨어 매뉴얼 제작</li>\n</ul>',
          logos: [211],
          date_published: '2022-05-09T21:18:06.000Z',
          main_cat: 1,
          categories: [1],
          industries: [2],
          sectors: [4, 3],
          logoFiles: [
            {
              id: 211,
              name: 'Eco Power.png',
              url: '/media/20220527/1653631918.png',
              thumb_url: '/media/20220527/thumb-1653631918.png',
              mimetype: 'image/png',
              size: 29594,
              date_uploaded: '2022-05-26T21:11:58.000Z',
              uploader_id: 1,
            },
          ],
        },
        {
          id: 4,
          image_thumb_url: '/media/20220510/thumb-1652163345.jpg',
          image_url: '/media/20220510/1652163345.jpg',
          name: 'PT COUPLING',
          subname: '-',
          description:
            '<ul>\n<li>제품 홍보를 목적으로 모든 제품군에 대한 특징과 장점을 설명하는 종합 제품 카탈로그 제작</li>\n</ul>',
          logos: [210],
          date_published: '2022-05-09T21:16:10.000Z',
          main_cat: 1,
          categories: [1],
          industries: [2],
          sectors: [2],
          logoFiles: [
            {
              id: 210,
              name: 'PT couplings.png',
              url: '/media/20220527/1653631904.png',
              thumb_url: '/media/20220527/thumb-1653631904.png',
              mimetype: 'image/png',
              size: 27428,
              date_uploaded: '2022-05-26T21:11:44.000Z',
              uploader_id: 1,
            },
          ],
        },
        {
          id: 3,
          image_thumb_url: '/media/20220510/thumb-1652163284.jpg',
          image_url: '/media/20220510/1652163284.jpg',
          name: '하니웰',
          subname: '-',
          description:
            '<ul>\n<li>기업 홍보와 함께 신규 모델의 특장점을 홍보하기 위한 브로슈어 제작</li>\n<li>장비 사용자가 본 장비를 올바르게 사용하고 정기적으로 점검 및 적절한 유지보수 작업을 수행할 수 있도록 돕기 위한 표준 매뉴얼 제작</li>\n</ul>',
          logos: [209],
          date_published: '2022-05-09T21:15:01.000Z',
          main_cat: 1,
          categories: [1],
          industries: [2],
          sectors: [2, 3],
          logoFiles: [
            {
              id: 209,
              name: 'Honeywell.png',
              url: '/media/20220527/1653631882.png',
              thumb_url: '/media/20220527/thumb-1653631882.png',
              mimetype: 'image/png',
              size: 10137,
              date_uploaded: '2022-05-26T21:11:22.000Z',
              uploader_id: 1,
            },
          ],
        },
        {
          id: 2,
          image_thumb_url: '/media/20220510/thumb-1652163061.jpg',
          image_url: '/media/20220510/1652163061.jpg',
          name: '경동 나비엔',
          subname: '-',
          description:
            '<ul>\n<li>신규 모델의 특장점에 대하여 홍보 및 외부 영업 자료로 사용하기 위해 디자인적 완성도를 높인 제품 카탈로그 제작</li>\n</ul>',
          logos: [208],
          date_published: '2022-05-09T21:12:50.000Z',
          main_cat: 1,
          categories: [1],
          industries: [1],
          sectors: [2, 3],
          logoFiles: [
            {
              id: 208,
              name: 'Navien.png',
              url: '/media/20220527/1653631850.png',
              thumb_url: '/media/20220527/thumb-1653631850.png',
              mimetype: 'image/png',
              size: 11649,
              date_uploaded: '2022-05-26T21:10:50.000Z',
              uploader_id: 1,
            },
          ],
        },
        {
          id: 1,
          image_thumb_url: '/media/20220509/thumb-1652114187.jpg',
          image_url: '/media/20220509/1652114187.jpg',
          name: 'CUCHEN',
          subname: ' ',
          description:
            '<ul>\n<li>사용자가 제품 구매 후 기본적인 사용법을 익히고 적절한 유지보수 방법 및 보증 내용에 대해 이해를 돕는 표준 매뉴얼 제작</li>\n<li>고급 모델 포지셔닝으로 매뉴얼의 문서 레이아웃이 아닌 디자인 요소가 반영된 디자인 매뉴얼 제작</li>\n</ul>',
          logos: [207],
          date_published: '2022-05-09T07:42:30.000Z',
          main_cat: 1,
          categories: [1],
          industries: [1],
          sectors: [1, 2],
          logoFiles: [
            {
              id: 207,
              name: 'Cuchen.png',
              url: '/media/20220527/1653631829.png',
              thumb_url: '/media/20220527/thumb-1653631829.png',
              mimetype: 'image/png',
              size: 11661,
              date_uploaded: '2022-05-26T21:10:29.000Z',
              uploader_id: 1,
            },
          ],
        },
      ]);
      let response = await axios({
        method: 'post',
        url: '/api/portfolio/clients',
      });
      store.commit(
        'SET_PORTFOLIO_CLIENTS',
        response.data.clients || []
      );
    } catch {
      console.log('error fetching clients');
    }
  },
};
